/* ==========================================================================================
   MES BRACELET BUILDER v2 — RENDER LAYER · fidelity rewrite 29 Aug 2026 (H296)

   Every style object in this file is TRANSCRIBED from `builder/Bracelet Builder Mobile
   v2.dc.html` — the ticket's source of truth. Do not tidy values. The first build
   interpreted the README and was rejected on sight; this one copies the design.

   Logic stays in MesBraceletCore (36 tests). This file renders, listens, and calls in.
   ⛔ Every displayed price is the ₹25 BUCKET (cart contract), where the prototype showed
   the raw total — the one deliberate divergence, ruled by Shrey.
   ========================================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-mzbb]');
  if (!root || !window.MesBraceletCore) { return; }
  var Core = window.MesBraceletCore;
  var SID = root.getAttribute('data-section-id');

  function readJSON(sel) {
    var el = document.querySelector(sel);
    if (!el) { return null; }
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  var catData = readJSON('[data-mzbb-catalogue="' + SID + '"]');
  var cfg = readJSON('[data-mzbb-config="' + SID + '"]') || {};
  if (!catData || !catData.stones || !catData.stones.length) { return; }
  Core.loadCatalogue(catData);
  var HW = Core.catalogue.hardware;
  var BY_ID = Core.catalogue.byId;
  var VARIANT_MAP = cfg.variantMap || {};
  var CLASP_BASE = cfg.claspBase || '';
  var CLASP_URLS = cfg.claspUrls || null;

  /* ---------- design constants, verbatim ---------- */
  /* V9.28.155 (H500): the ring's geometry, metals and faces now live in the core (drawPreview) so the
     builder and Mesmerize OS draw a bracelet with ONE piece of code. These are aliases, not copies. */
  var ACCENT = Core.ACCENT;
  var COLORS = Core.COLORS;
  var CUBE_METAL = Core.CUBE_METAL;
  var GLASS = {
    border: '1px solid rgba(255,255,255,0.6)',
    background: 'linear-gradient(160deg,rgba(253,252,246,0.72),rgba(244,240,226,0.55))',
    backdropFilter: 'blur(14px) saturate(1.3)', webkitBackdropFilter: 'blur(14px) saturate(1.3)',
    boxShadow: '0 4px 18px rgba(0,0,0,0.06), inset 0 1px 0 rgba(255,255,255,0.7)'
  };
  var GLASS_ON = {
    border: '1px solid rgba(93,139,215,0.45)',
    background: 'linear-gradient(160deg,rgba(253,252,246,0.78),rgba(93,139,215,0.12))',
    color: ACCENT, fontWeight: '700',
    backdropFilter: 'blur(14px) saturate(1.3)', webkitBackdropFilter: 'blur(14px) saturate(1.3)',
    boxShadow: '0 8px 16px rgba(0,0,0,0.12), inset 0 1px 0 rgba(255,255,255,0.8)'
  };
  var FOIL = 'repeating-linear-gradient(145deg,#8A5F12,#B98A1E 60px,#E8C255 110px,#F3D77E 140px,#B98A1E 190px,#8A5F12 260px)';
  /* V9.28.160 (Shrey 1A, 5 Oct, A996): six presets swapped a switched-off stone for an in-stock one from the same intent
     group (Calm/Healing/Balance lost Amazonite, Clarity Blue Apatite, Confidence Pink Tourmaline, Grounding Black Agate). */
  var PRESETS = [
    { name: 'Wealth', stones: ['pyrite', 'malachite', 'citrine'], metal: 'gold', charm: 'core_goldhematite' },
    { name: 'Luck', stones: ['aventurine', 'glossonyx', 'malachite'], metal: 'silver', charm: 'core_evileye' },
    { name: 'Calm', stones: ['angelite', 'howlite', 'amethyst'], metal: 'silver', charm: 'none' },
    { name: 'Love', stones: ['strawberry', 'howlite', 'rose'], metal: 'gold', charm: 'none' },
    { name: 'Protection', stones: ['glossonyx', 'obsidian', 'hakik'], metal: 'black', charm: 'evileye' },
    { name: 'Focus', stones: ['sodalite', 'lapis', 'larvikite'], metal: 'silver', charm: 'none' },
    { name: 'Strength', stones: ['redjasper', 'dragonblood', 'matteonyx'], metal: 'black', charm: 'trishul' },
    { name: 'Healing', stones: ['hemimorphite', 'howlite', 'afturquoise'], metal: 'silver', charm: 'none' },
    { name: 'Sleep', stones: ['howlite', 'multimoon', 'angelite'], metal: 'silver', charm: 'none' },
    { name: 'Confidence', stones: ['tigereye', 'redtiger', 'carnelian'], metal: 'gold', charm: 'core_goldhematite' },
    { name: 'Clarity', stones: ['clearquartz', 'selenite', 'auraquartz'], metal: 'silver', charm: 'none' },
    { name: 'Grounding', stones: ['lava', 'greyhematite', 'matteonyx'], metal: 'black', charm: 'core_omonyx' },
    { name: 'Devotion', stones: ['rudraksh', 'matteonyx', 'selenite'], metal: 'silver', charm: 'om' },
    { name: 'New start', stones: ['treeagate', 'aventurine', 'moonstone'], metal: 'silver', charm: 'none' },
    { name: 'Balance', stones: ['fluorite', 'multimoon', 'rainbowmoon'], metal: 'silver', charm: 'none' }
  ];
  var COLOR_HEAD = ['sunstone', 'carnelian', 'redjasper', 'ruby', 'garnet', 'pinktourmaline', 'redtiger', 'tigereye', 'rudraksh', 'amber', 'orangeavent', 'multimoon', 'citrine', 'calcite'];
  var COLOR_GREEN_BLUE = ['aventurine', 'fluorite', 'jade', 'emerald', 'malachite', 'mossagate', 'amazonite', 'hemimorphite', 'rainbowmoon', 'angelite', 'bluelace', 'afturquoise', 'apatite', 'sodalite', 'kyanite', 'lapis'];
  var COLOR_TAIL = ['whitecoral', 'selenite', 'pearl', 'moonstone', 'howlite', 'treeagate', 'auraquartz', 'clearquartz', 'labradorite'];
  var COLOR_PRE_HEMATITE = ['pyrite', 'dragonblood', 'cateye', 'larvikite', 'saffordite'];

  function money(n) { return '₹' + n.toLocaleString('en-IN'); }
  function css(el, obj) { Object.keys(obj).forEach(function (k) { el.style[k] = obj[k]; }); }
  /* the design's stoneImg() and hardware() (metal disc gradients for finish swatches + elastic bar)
     live in the core with the ring drawing that uses them (H500) */
  var stoneImg = Core.stoneImg;
  var hardware = Core.hardware;

  /* ------------------------------------------------------------------------------ state */
  var st = {
    beads: [], size: null, construction: null, color: 'silver', surface: 'gloss',
    charm: 'none', cubeOn: false, initials: '', cubeMetal: 'silver', centreMode: 'core',
    box: 'kappa', mirror: true,
    active: -1, claspActive: false, sort: 'intent', sortDesc: false, luxOnly: false,
    showAll: false, palette: [], pickRemove: 0, resizePrompt: null, resizeDone: null,
    mirrorHint: 0, mirrorAsk: false, loadedName: '', startOpen: true, sizeAsk: null, sizeAuto: false,
    guideOpen: false
  };
  var history = [];
  var lastBucket = null, deltaVal = null, deltaT = null, deltaLabel = '';
  var saveTimer = null, loadedT = null;

  function pushHistory() { history.push({ beads: st.beads.slice(), size: st.size }); if (history.length > 40) { history.shift(); } }
  function set(patch, opts) {
    Object.keys(patch).forEach(function (k) { st[k] = patch[k]; });
    Core.normalise(st);
    announceCleared();
    render();
    if (!opts || !opts.silent) { scheduleSave(); }
  }

  /* V9.28.116: normalise() empties any bead whose stone is out of stock (a preset, a Customize-it or shared
     link, a saved design). Say so, once, in the loaded banner, so an empty slot never looks like a bug. */
  function announceCleared() {
    var n = st._clearedOos; delete st._clearedOos;
    if (!n) { return; }
    el.loadedText.innerHTML = '<strong style="color:#15171A;">' + n + (n === 1 ? ' bead is' : ' beads are') + ' out of stock right now.</strong> We left ' + (n === 1 ? 'its slot' : 'those slots') + ' empty; tap to pick a replacement.';
    el.loadedBanner.hidden = false;
    clearTimeout(loadedT);
    loadedT = setTimeout(function () { el.loadedBanner.hidden = true; }, 6000);
  }
  function $(sel) { return root.querySelector(sel); }
  /* the typical wrist size per size in CM (V9.28.161, Shrey 6 Oct: centimetres by default everywhere), the product page's
     bracelet chart "show" values (mes-pdp3-size-guide) */
  var SIZE_SHOW = { S: '14.0', M: '15.2', L: '16.5', XL: '18.3' };
  var GUIDE_ICON = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="#5d8bd7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="vertical-align:-3px; margin-right:5px;"><rect x="2.5" y="7.5" width="19" height="9" rx="1.5"/><path d="M7 7.5v3M11 7.5v4M15 7.5v3M19 7.5v4"/></svg>';
  function $$(sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  var el = {
    stage: $('[data-mzbb-stage]'), ring: $('[data-mzbb-ring]'), centre: $('[data-mzbb-ringcentre]'),
    saved: $('[data-mzbb-saved]'), share: $('[data-mzbb-share]'), copied: $('[data-mzbb-copied]'),
    loadedBanner: $('[data-mzbb-loadedbanner]'), loadedText: $('[data-mzbb-loadedtext]'), loadedDismiss: $('[data-mzbb-loadeddismiss]'),
    mirror: $('[data-mzbb-mirror]'), mirrorLabel: $('[data-mzbb-mirrorlabel]'),
    undo: $('[data-mzbb-undo]'), undocap: $('[data-mzbb-undocap]'), reset: $('[data-mzbb-reset]'), autofill: $('[data-mzbb-autofill]'),
    mirrorask: $('[data-mzbb-mirrorask]'), mirroryes: $('[data-mzbb-mirroryes]'), mirrorno: $('[data-mzbb-mirrorno]'),
    startsummary: $('[data-mzbb-startsummary]'), startcaret: $('[data-mzbb-startcaret]'), startopen: $('[data-mzbb-startopen]'), presetrow: $('[data-mzbb-presetrow]'),
    sortslider: $('[data-mzbb-sortslider]'), lux: $('[data-mzbb-lux]'), luxlabel: $('[data-mzbb-luxlabel]'),
    grid: $('[data-mzbb-grid]'), showall: $('[data-mzbb-showall]'),
    sizehead: $('[data-mzbb-sizehead]'), sizes: $('[data-mzbb-sizes]'), sizewarn: $('[data-mzbb-sizewarn]'),
    guide: $('[data-mzbb-guide]'), guidebody: $('[data-mzbb-guidebody]'), sg2: $('mes-sg2-wrist'),
    buildhead: $('[data-mzbb-buildhead]'), magprice: $('[data-mzbb-magprice]'), elasticprice: $('[data-mzbb-elasticprice]'),
    finish: $('[data-mzbb-finish]'), finishrow: $('[data-mzbb-finishrow]'),
    centretabs: $('[data-mzbb-centretabs]'), charmgrid: $('[data-mzbb-charmgrid]'), cubecard: $('[data-mzbb-cubecard]'),
    boxes: $('[data-mzbb-boxes]'),
    lines: $('[data-mzbb-lines]'), total: $('[data-mzbb-total]'), totalshift: $('[data-mzbb-totalshift]'), delta: $('[data-mzbb-delta]'),
    atc: $('[data-mzbb-atc]'), atcHint: $('[data-mzbb-atchint]'),
    sticky: $('[data-mzbb-sticky]'), stickyprice: $('[data-mzbb-stickyprice]'), stickyshift: $('[data-mzbb-stickyshift]'),
    stickydelta: $('[data-mzbb-stickydelta]'), stickyAtc: $('[data-mzbb-atc-sticky]'), progress: $('[data-mzbb-progress]')
  };

  function jumpTo(sel) {
    var t = root.querySelector(sel);
    if (!t) { return; }
    var hdr = root.querySelector('[data-sticky-header]');
    var off = (hdr ? hdr.getBoundingClientRect().height : 80) + 14;
    var r = t.getBoundingClientRect();
    window.scrollTo({ top: window.scrollY + r.top - off, behavior: 'smooth' });
  }

  /* ---------------------------------------------- ring — drawn by the core (H500) */
  var claspAspect = Core.CLASP_ASPECT_DEFAULT; /* the design's own height formula uses 385/900; the real
    image aspect is read on load and used for the IMG height so the render is never squashed */
  /* the versioned-URL lookup (and why it must carry ?v=) lives in Core.claspUrl */
  function claspUrl() {
    return Core.claspUrl(st.color, st.surface, CLASP_URLS, CLASP_BASE);
  }
  function primeClaspAspect() {
    var img = new Image();
    img.onload = function () { if (img.naturalWidth > 0) { claspAspect = img.naturalHeight / img.naturalWidth; render(); } };
    img.src = claspUrl();
  }

  /* ⛔ The DRAWING is Core.drawPreview(), the same function Mesmerize OS's Production page calls, so the
     two can never drift. Only builder UI state is applied here: the selected bead (highlight), the mirror
     ghost, the remove-mode ring, the clasp focus, and the taps. */
  function renderRing() {
    var n = st.beads.length;
    var mirI = st.mirror && st.active >= 0 ? n - 1 - st.active : -1;
    var r = Core.drawPreview(el.ring, st, {
      claspUrls: CLASP_URLS, claspBase: CLASP_BASE, claspAspect: claspAspect,
      stageWidth: el.stage.clientWidth, interactive: true,
      highlight: st.pickRemove === 0 ? st.active : -1,
      decorate: function (node, info) {
        if (info.kind === 'clasp') {
          if (st.claspActive) { node.style.boxShadow = Core.SELECT_RING; }
          node.addEventListener('click', function (e) { e.stopPropagation(); onClaspTap(); });
          return;
        }
        var i = info.index;
        if (!info.highlighted) {
          if (i === mirI && mirI !== st.active && st.pickRemove === 0) { node.style.boxShadow = '0 0 0 2px rgba(93,139,215,0.35)'; }
          else if (st.pickRemove > 0 && info.id && !info.isCube && !info.isCharm) { node.style.boxShadow = '0 0 0 2px rgba(196,99,58,0.65), 0 0 0 5px rgba(196,99,58,0.14)'; }
        }
        node.addEventListener('click', function (e) { e.stopPropagation(); onBeadTap(i, info.id, info.isCube, info.isCharm); });
      }
    });
    renderRingCentre(r.placed, r.n);
  }

  /* the centre readout — the design's centreTitle/centreSub state machine, ported */
  function renderRingCentre(placed, n) {
    var html = '';
    var activeStone = null;
    if (st.active > -1 && st.beads.length) {
      var ci = Core.centreIndices(st, st.beads.length);
      if (st.cubeOn && st.active === ci.top) { activeStone = { name: 'Initials cube · ' + (st.initials || 'AB').toUpperCase(), intent: CUBE_METAL[st.cubeMetal].label + ' · laser-etched' }; }
      else if (st.charm !== 'none' && st.active === ci.top) { var cd = Core.charmDef(st.charm); activeStone = { name: (cd.tab === 'silver' ? '925 Silver ' : '') + cd.name, intent: cd.meaning || 'Centre charm' }; }
      else if (st.beads[st.active]) { var s2 = BY_ID[st.beads[st.active]]; if (s2) { activeStone = { name: s2.name, intent: s2.intent }; } }
    }
    var title = '', sub = '', count = '';
    if (st.pickRemove > 0) {
      title = 'Remove ' + st.pickRemove + (st.pickRemove === 1 ? ' bead' : ' beads'); sub = 'Tap beads to remove them';
    } else if (st.mirror && st.mirrorHint === 1) {
      html = '<div style="display:flex; flex-direction:column; align-items:center; gap:5px;">' +
        '<button type="button" data-mirroroff style="pointer-events:auto; display:inline-flex; align-items:center; gap:6px; min-height:32px; padding:7px 12px; border-radius:100px; border:1px solid rgba(93,139,215,0.45); background:rgba(93,139,215,0.1); color:#3C6BB8; font-family:\'Jost\',\'Futura\',sans-serif; font-size:11.5px; font-weight:700; cursor:pointer;">Mirror mode on</button>' +
        '<div style="font-size:10.5px; letter-spacing:0.06em; color:#6E737A;">both sides fill together</div></div>';
    } else if (st.claspActive) {
      title = st.construction ? (st.construction === 'elastic' ? 'Elastic band' : 'MagSnap 4 · ' + hardware(st.color, st.surface).label) : 'Choose your closure';
      sub = st.construction ? 'Your closure · change it below' : '';
    } else if (activeStone) {
      var ci2 = Core.centreIndices(st, st.beads.length);
      var swapOn = st.active === ci2.top && st.charm === 'none' && !st.cubeOn;
      html = '<div style="font-family:\'Jost\',\'Futura\',sans-serif; font-size:15px; font-weight:700; color:#15171A; line-height:1.15;">' + activeStone.name + '</div>' +
        '<div style="margin-top:3px; font-size:10.5px; letter-spacing:0.06em; color:#6E737A;">' + activeStone.intent + '</div>' +
        '<div style="margin-top:6px; font-size:9.5px; letter-spacing:0.1em; text-transform:uppercase; color:#A2A6AC; font-weight:600;">' + placed + '/' + n + ' placed</div>' +
        (swapOn ? '<button type="button" data-centreswap style="pointer-events:auto; margin-top:7px; padding:7px 12px; border-radius:100px; border:1px solid rgba(93,139,215,0.45); background:rgba(93,139,215,0.12); color:#3C6BB8; font-size:10.5px; font-weight:700; cursor:pointer;">Upgrade to a centre piece</button>' : '');
    } else if (!st.beads.length || !placed) {
      title = st.loadedName || 'Select a design or\nclick on a stone to begin';
      sub = '';
    } else {
      title = st.loadedName || (placed + '/' + n + ' placed');
      sub = !st.size ? 'Step 2 · pick your size' : !st.construction ? 'Step 3 · choose your closure' : st.active < 0 ? 'Tap a bead to edit it' : '';
    }
    if (!html) {
      html = '<div style="font-family:\'Jost\',\'Futura\',sans-serif; font-size:13px; font-weight:700; color:#15171A; line-height:1.25; white-space:pre-line;">' + title + '</div>' +
        (sub ? '<div style="margin-top:4px; font-size:10.5px; letter-spacing:0.06em; color:#6E737A;">' + sub + '</div>' : '');
    }
    el.centre.innerHTML = html;
    var mo = el.centre.querySelector('[data-mirroroff]');
    if (mo) { mo.addEventListener('click', function (e) { e.stopPropagation(); set({ mirror: false, mirrorHint: 2 }); }); }
    var cs = el.centre.querySelector('[data-centreswap]');
    if (cs) { cs.addEventListener('click', function (e) { e.stopPropagation(); jumpTo('[data-centre-anchor]'); }); }
  }

  /* ------------------------------------------------------------------------ interactions */
  function onBeadTap(i, id, isCube, isCharm) {
    if (st.pickRemove > 0) {
      if (isCube || isCharm || !id) { return; }
      var out = st.beads.slice();
      var j = out.length - 1 - i, removed = 1;
      out.splice(i, 1);
      if (st.mirror && j !== i && st.pickRemove > 1 && out[j > i ? j - 1 : j]) { out.splice(j > i ? j - 1 : j, 1); removed = 2; }
      var left = Math.max(0, st.pickRemove - removed);
      if (left <= 0) {
        var rp = st.resizePrompt;
        set({ beads: out, pickRemove: 0, resizePrompt: null, size: rp ? rp.to : st.size, active: -1, sizeAsk: null, resizeDone: null });
      } else { set({ beads: out, pickRemove: left }); }
      return;
    }
    set({ active: i, claspActive: false }, { silent: true });
    if (isCube || isCharm) { jumpTo('[data-centre-anchor]'); }
  }
  function onClaspTap() {
    set({ claspActive: true, active: -1 }, { silent: true });
    jumpTo('[data-build-anchor]');
  }

  function placeStone(stoneId) {
    var n = st.beads.length;
    if (!n) {
      rememberPalette(stoneId);
      /* the design lets you start from a stone: default M + MagSnap, place at 0 */
      var cnt = Core.beadCount('M', 'magsnap');
      pushHistory();
      var fresh = new Array(cnt).fill(null);
      fresh = Core.placeBead(fresh, 0, stoneId, st.mirror);
      set({ size: 'M', construction: st.construction || 'magsnap', beads: fresh, active: Core.nextIndex(fresh, 0, st.mirror), mirrorHint: st.mirror && !st.mirrorHint ? 1 : st.mirrorHint });
      armMirrorHint();
      return;
    }
    var i = st.active >= 0 ? st.active : Core.nextIndex(st.beads, -1, st.mirror);
    if (i < 0) { i = 0; } /* a full bracelet has no empty slot; start editing at the top bead */
    pushHistory();
    var out = Core.placeBead(st.beads, i, stoneId, st.mirror);
    rememberPalette(stoneId);
    var first = st.mirror && !st.mirrorHint;
    set({ beads: out, active: advanceFrom(out, i), mirrorHint: first ? 1 : st.mirrorHint });
    if (first) { armMirrorHint(); }
  }

  /* ⛔ Shrey, 29 Aug: "even on selecting manually, it doesn't auto progress after changing a
     stone". Core.nextIndex only finds an EMPTY slot, so on a FULL bracelet - which is what every
     preset produces - it returns -1, the focus is dropped and the shopper has to re-tap a bead
     for each change. Fall back to walking the ring in order: on a mirrored build that is the
     unique half (the mirror twin is written at the same time), otherwise every bead. */
  function advanceFrom(beads, i) {
    var nxt = Core.nextIndex(beads, i, st.mirror);
    if (nxt >= 0) { return nxt; }
    var n = beads.length;
    if (!n) { return -1; }
    var last = st.mirror ? Math.floor((n - 1) / 2) : n - 1;
    return i >= last ? 0 : i + 1;
  }
  var mirrorHintT = null;
  function armMirrorHint() {
    clearTimeout(mirrorHintT);
    mirrorHintT = setTimeout(function () { if (st.mirrorHint === 1) { set({ mirrorHint: 2 }, { silent: true }); } }, 3200);
  }
  function rememberPalette(stoneId) {
    var p = st.palette.filter(function (x) { return x !== stoneId; });
    p.unshift(stoneId);
    st.palette = p.slice(0, 8);
  }

  function toggleMirror() {
    if (!st.mirror) {
      if (st.beads.length && !Core.isSymmetric(st.beads)) { set({ mirror: true, mirrorAsk: true }); return; }
      set({ mirror: true, mirrorAsk: false });
    } else { set({ mirror: false, mirrorAsk: false }); }
  }
  function doUndo() {
    if (!history.length) { return; }
    var prev = history.pop();
    set({ beads: prev.beads, size: prev.size, pickRemove: 0, resizePrompt: null, sizeAsk: null, resizeDone: null, active: -1 });
  }
  function doReset() {
    pushHistory();
    set({ beads: new Array(st.beads.length).fill(null), palette: [], active: -1, charm: 'none', cubeOn: false, initials: '', centreMode: 'core', loadedName: '', pickRemove: 0, resizePrompt: null });
  }
  function doAutoFill() {
    pushHistory();
    set({ beads: Core.autoFill(st.beads, st.mirror), active: -1 });
  }

  function pickSize(sizeId) {
    if (st.size === sizeId) { if (st.sizeAuto) { set({ sizeAuto: false }); } return; }
    var z = Core.sizeRow(sizeId);
    if (!z) { return; }
    var newN = Core.beadCount(sizeId, st.construction || 'magsnap');
    var oldN = st.beads.length;
    if (!oldN) { set({ size: sizeId, sizeAuto: false, beads: new Array(newN).fill(null), active: 0, sizeAsk: sizeId }); return; }
    pushHistory();
    if (newN >= oldN) {
      set({ size: sizeId, sizeAuto: false, beads: Core.adjustTo(newN, st.beads, st.mirror), sizeAsk: sizeId, resizeDone: null });
    } else {
      var before = st.beads.slice(), beforeSize = st.size;
      var out = Core.adjustTo(newN, st.beads, st.mirror);
      set({ size: sizeId, sizeAuto: false, beads: out, sizeAsk: sizeId, resizeDone: { id: sizeId, drop: oldN - newN, prevBeads: before, prevSize: beforeSize } });
    }
  }

  function pickClosure(kind) {
    if (st.construction === kind) { return; }
    pushHistory();
    var target = st.size ? Core.beadCount(st.size, kind) : 0;
    var patch = { construction: kind, claspActive: false, active: -1 };
    if (st.beads.length && target && target !== st.beads.length) { patch.beads = Core.adjustTo(target, st.beads, st.mirror); }
    else if (!st.beads.length && target) { patch.beads = new Array(target).fill(null); patch.active = 0; }
    set(patch);
  }

  /* ---------------------------------------------- custom-order notice (V9.28.115, Shrey 29 Sep 2026)
     "When the user clicks on Customize it or any of the preset designs, I want a pop-up to show for 10 seconds.
     It should warn customers that COD is not available, and neither are size exchanges, and give an estimated
     price change for the same design... two buttons: go ahead and cancel. A similar warning without the price
     for Add to Cart."
     One notice, two moments (V9.28.133: the preset tap was dropped, Shrey 1 Oct): a design arriving from a
     product's Customize it link (price vs the ready-made one it came from) and Add to cart (no price). It
     CONTINUES ON ITS OWN after 10 seconds (the button fills as the clock runs); Cancel, the scrim or Esc cancel.
     Both show every time. The words live in the section's Liquid (William's to finalise); only the price line is built here. */
  var NOTICE_MS = 10000;
  var noticeOpen = false;
  function customNotice(opts, onGo, onCancel) {
    var box = root.querySelector('[data-mzbb-notice]');
    /* V9.28.120: switched off in the customizer (the default until H421's gates clear) = straight through */
    if (box && box.hasAttribute('data-mzbb-notice-off')) { if (onGo) { onGo(); } return; }
    if (!box || noticeOpen) { if (!box && onGo) { onGo(); } return; }
    noticeOpen = true;
    var priceBox = box.querySelector('[data-mzbb-notice-price]');
    var row = box.querySelector('[data-mzbb-notice-pricerow]');
    var go = box.querySelector('[data-mzbb-notice-go]');
    var label = box.querySelector('[data-mzbb-notice-golabel]');
    var auto = box.querySelector('[data-mzbb-notice-auto]');
    label.textContent = opts.goLabel || 'Continue';
    if (opts.custom) {
      var html = '';
      if (opts.ready) {
        var diff = opts.custom - opts.ready;
        /* no strikethrough: it would read as "old price, you save", and the custom one usually costs MORE (William, H421) */
        html = '<span>Ready-made ' + money(opts.ready) + '</span><span>Your design <b>' + money(opts.custom) + '</b></span>' +
          (diff ? '<span class="mzbb-notice__delta">' + (diff > 0 ? '+' : '−') + money(Math.abs(diff)) + '</span>' : '<span class="mzbb-notice__delta">Same price</span>');
      } else {
        html = '<span>About <b>' + money(opts.custom) + '</b> at your size</span>';
      }
      row.innerHTML = html;
      priceBox.hidden = false;
    } else {
      priceBox.hidden = true;
    }
    box.style.setProperty('--mzbb-notice-ms', NOTICE_MS + 'ms');
    box.hidden = false;
    box.classList.remove('is-counting'); void box.offsetWidth; box.classList.add('is-counting');
    var left = Math.round(NOTICE_MS / 1000);
    var tick = function () { auto.textContent = 'Continuing in ' + left + 's'; };
    tick();
    var iv = setInterval(function () { left -= 1; if (left > 0) { tick(); } }, 1000);
    var t = setTimeout(function () { finish(true); }, NOTICE_MS);
    var prevFocus = document.activeElement;
    function onKey(e) { if (e.key === 'Escape') { finish(false); } }
    function onGoClick() { finish(true); }
    function onCancelClick() { finish(false); }
    var cancels = box.querySelectorAll('[data-mzbb-notice-cancel]');
    function finish(ok) {
      clearTimeout(t); clearInterval(iv);
      document.removeEventListener('keydown', onKey);
      go.removeEventListener('click', onGoClick);
      Array.prototype.forEach.call(cancels, function (c) { c.removeEventListener('click', onCancelClick); });
      box.hidden = true; box.classList.remove('is-counting'); auto.textContent = '';
      stripIncoming();
      noticeOpen = false;
      if (prevFocus && prevFocus.focus) { try { prevFocus.focus({ preventScroll: true }); } catch (e) {} }
      if (ok) { if (onGo) { onGo(); } } else if (onCancel) { onCancel(); }
    }
    document.addEventListener('keydown', onKey);
    go.addEventListener('click', onGoClick);
    Array.prototype.forEach.call(cancels, function (c) { c.addEventListener('click', onCancelClick); });
    try { go.focus({ preventScroll: true }); } catch (e) {}
  }
  /* V9.28.133 (Shrey, 1 Oct): a preset tap no longer shows the notice. It shows only on Add to cart and when a design
     arrives from a product's Customize it link; shoppers try presets freely without a pop-up in the way. */
  function loadPreset(p) { applyPreset(p); }
  function presetPatch(p) {
    var construction = st.construction || 'magsnap';
    var size = st.size || 'M';
    var cnt = Core.beadCount(size, construction);
    var base = p.stones[0], alt = p.stones[1] || base, accent = p.stones[2] || base;
    /* the design's recipe: build the half and mirror it, accent centred */
    var out = new Array(cnt);
    var half = Math.floor(cnt / 2);
    for (var j = 0; j < half; j++) {
      var s = j === 0 ? accent : (j % 2 ? base : alt);
      out[half - 1 - j] = s;
      out[half + j] = s;
    }
    if (cnt % 2) { out[cnt - 1] = base; }
    return {
      beads: out, palette: [base, alt, accent], size: size, construction: construction,
      /* V9.28.225: M is only a stand-in when no size was picked; it stays "not set" until the shopper taps one */
      sizeAuto: st.size ? !!st.sizeAuto : true,
      color: p.metal || st.color, charm: p.charm || 'none', cubeOn: false, initials: '',
      _lastCentre: 'charm',
      centreMode: (p.charm && p.charm.indexOf('core') === 0) ? 'core' : (p.charm && p.charm !== 'none') ? 'silver' : st.centreMode,
      active: -1, loadedName: p.name
    };
  }
  function applyPreset(p) {
    pushHistory();
    set(presetPatch(p));
    el.loadedText.innerHTML = '<strong style="color:#15171A;">' + p.name + ' loaded.</strong> Every bead, the clasp and the centre piece are yours to change.';
    el.loadedBanner.hidden = false;
    var bar = el.loadedBanner.querySelector('.mz-loadbar');
    if (bar) { bar.style.animation = 'none'; void bar.offsetWidth; bar.style.animation = 'mzLoadBar 4s linear forwards'; }
    clearTimeout(loadedT);
    loadedT = setTimeout(function () { el.loadedBanner.hidden = true; }, 4000);
  }

  /* ------------------------------------------------------------- share · autosave · entry */
  var SAVE_KEY = 'mz_builder_autosave';
  function scheduleSave() {
    clearTimeout(saveTimer);
    saveTimer = setTimeout(function () {
      var rec = {
        beads: st.beads, size: st.size, construction: st.construction, color: st.color,
        surface: st.surface, box: st.box, charm: st.charm, cubeOn: st.cubeOn,
        initials: st.initials, cubeMetal: st.cubeMetal, centreMode: st.centreMode,
        designName: st.loadedName, mirror: st.mirror, palette: st.palette, sizeAuto: !!st.sizeAuto
      };
      try {
        localStorage.setItem(SAVE_KEY, JSON.stringify(rec));
        var back = localStorage.getItem(SAVE_KEY);
        if (back && back.length > 2) { el.saved.hidden = false; }
      } catch (e) { /* private mode — never break the builder over a badge */ }
    }, 600);
  }
  /* V9.28.225 (Shrey A1356, 15 Oct): a visitor with no link and no saved design starts on a finished bracelet (Wealth,
     the most-tapped design) instead of an empty one; a third of ad visitors never tapped the empty start. Written into
     st directly, not via set(), so it is not autosaved: an untouched start never comes back as "your last design".
     Size stays "not set" (sizeAuto) until the shopper picks one; Add to Cart asks for it. */
  function startOnPreset(name) {
    var ok = PRESETS.filter(function (p) {
      return p.stones.every(Core.stoneOk) && (!p.charm || p.charm === 'none' || Core.isOn(p.charm));
    });
    var p = ok.filter(function (x) { return x.name === name; })[0] || ok[0];
    if (!p) { return; }
    var patch = presetPatch(p);
    Object.keys(patch).forEach(function (k) { if (k in st) { st[k] = patch[k]; } });
    Core.normalise(st);
  }
  function tryRestore() {
    var rec = null;
    try { rec = JSON.parse(localStorage.getItem(SAVE_KEY) || 'null'); } catch (e) { rec = null; }
    if (!rec || !rec.beads || !rec.beads.length) { return false; }
    Object.keys(rec).forEach(function (k) { if (k in st) { st[k] = rec[k]; } });
    if (rec.designName) { st.loadedName = rec.designName; }
    Core.normalise(st);
    st.mirrorHint = 2;
    el.loadedText.innerHTML = '<strong style="color:#15171A;">Your last design loaded.</strong> Every bead, the clasp and the centre piece are yours to change.';
    el.loadedBanner.hidden = false;
    clearTimeout(loadedT);
    loadedT = setTimeout(function () { el.loadedBanner.hidden = true; }, 4000);
    return true;
  }
  function onShare() {
    var url = location.origin + location.pathname + '?' + Core.encodeBuild(st);
    var done = function () {
      el.copied.hidden = false;
      setTimeout(function () { el.copied.hidden = true; }, 1600);
    };
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        var t = setTimeout(done, 800); /* clipboard can hang in hidden tabs — never let it block the UI */
        navigator.clipboard.writeText(url).then(function () { clearTimeout(t); done(); }, function () { clearTimeout(t); done(); });
      } else { done(); }
    } catch (e) { done(); }
  }
  var incomingNotice = null;
  /* ⛔ window.history, NOT history: inside this file `history` is the builder's own UNDO stack, so a bare
     history.replaceState throws "not a function" (measured on dev, caught silently by the try below). */
  function stripIncoming() {
    try {
      var q = new URLSearchParams(location.search);
      if (!q.has('rp') && !q.has('rh')) { return; }
      q.delete('rp'); q.delete('rh');
      window.history.replaceState(window.history.state, '', location.pathname + '?' + q.toString() + location.hash);
    } catch (e) {}
  }
  function tryIncoming() {
    if (!location.search || location.search.indexOf('d=') < 0) { return false; }
    var decoded = Core.decodeBuild(location.search.slice(1));
    if (!decoded.beads.length) { return false; }
    /* V9.28.115: a product's Customize it link also carries the ready-made price (rp, rupees) and the product
       handle (rh) so the notice can compare prices and Cancel can go back. Read once, then stripped from the
       address bar so a shared or bookmarked link never re-triggers it. */
    try {
      var qp = new URLSearchParams(location.search);
      var rp = parseInt(qp.get('rp'), 10), rh = qp.get('rh');
      if (rh && /^[a-z0-9-]+$/i.test(rh)) {
        incomingNotice = { ready: rp > 0 ? rp : null, handle: rh };
        stripIncoming();
      }
    } catch (e) {}
    Object.keys(decoded).forEach(function (k) { if (k in st) { st[k] = decoded[k]; } });
    if (!st.size) { st.size = 'M'; st.sizeAuto = true; }
    if (!st.construction) { st.construction = 'magsnap'; }
    var want = Core.beadCount(st.size, st.construction);
    /* V9.28.96 (H402): a design's "Customise" link arrives written at size M with the shopper's own size and
       closure swapped in, so the bead count often differs. Resize it the way the size buttons do (adjustTo keeps
       the pattern centred and symmetric) instead of cutting the end off or padding it with empty gaps. */
    if (want && st.beads.length !== want) { st.beads = Core.adjustTo(want, st.beads, st.mirror); }
    Core.normalise(st);
    /* V9.28.126 (Shrey, 30 Sep: recipes for the 925 silver and the initials designs): open the centre tab the design
       actually uses, so a 925 charm or the initials cube is what the shopper sees first (it used to stay on Core). */
    if (st.cubeOn) { st.centreMode = 'cube'; }
    else if (st.charm && st.charm !== 'none') {
      var inDef = (HW.charms || []).filter(function (c) { return c.id === st.charm; })[0];
      st.centreMode = inDef && inDef.tab === 'silver' ? 'silver' : 'core';
    }
    st.mirrorHint = 2;
    el.loadedText.innerHTML = '<strong style="color:#15171A;">A shared design loaded.</strong> Every bead, the clasp and the centre piece are yours to change.';
    el.loadedBanner.hidden = false;
    clearTimeout(loadedT);
    loadedT = setTimeout(function () { el.loadedBanner.hidden = true; }, 4000);
    return true;
  }

  function addToCart(e, confirmed) {
    var price = st.beads.length ? Core.priceOf(st) : null;
    if (!price) { jumpTo('[data-stones-anchor]'); return; }
    var ci = Core.centreIndices(st, st.beads.length);
    var emptyCount = st.beads.filter(function (b, i) { return !b && i !== ci.cube && i !== ci.charm; }).length;
    /* V9.28.126: an initials cube with no initials is not a finished design. A personalised product's Customize-it
       link arrives with the cube ON and the letters blank (only the shopper knows them); without this it could be
       ordered, and paid for, with nothing to engrave. */
    var needInitials = !!st.cubeOn && !(st.initials || '').length;
    var complete = emptyCount === 0 && !!st.size && !st.sizeAuto && !!st.construction && !needInitials;
    if (!complete) {
      /* the design's nudge: scroll to the pending step with a highlight pulse */
      var sel = (!st.beads.some(Boolean)) || emptyCount ? '[data-stones-anchor]' : (!st.size || st.sizeAuto) ? '[data-size-anchor]' : !st.construction ? '[data-build-anchor]' : '[data-centre-anchor]';
      if (sel === '[data-size-anchor]') { el.atcHint.textContent = 'Pick your size first. It is made to your wrist, so sizes can’t be exchanged.'; }
      if (needInitials && sel === '[data-centre-anchor]') {
        if (st.centreMode !== 'cube' && st.centreMode !== 'personalised') { set({ centreMode: 'cube' }, { silent: true }); }
        el.atcHint.textContent = 'Type your initials for the cube first, or pick another centre piece.';
        setTimeout(function () { var ii = root.querySelector('[data-cubeinitials]'); if (ii) { try { ii.focus({ preventScroll: true }); } catch (err) { ii.focus(); } } }, 450);
      }
      var t = root.querySelector(sel);
      if (t) {
        t.style.transition = 'box-shadow .25s ease';
        t.style.borderRadius = '8px';
        t.style.boxShadow = '0 0 0 4px rgba(93,139,215,0.35)';
        jumpTo(sel);
        setTimeout(function () { t.style.boxShadow = 'none'; }, 900);
      }
      return;
    }
    /* V9.28.115: the custom-order notice (no price line) before the bracelet goes to the cart */
    if (confirmed !== true) {
      customNotice({ goLabel: 'Add to cart' }, function () { addToCart(null, true); });
      return;
    }
    /* ⛔ the price-authority guard REFUSES rather than sells at a stale price - but it used to
       `return` in silence, so Shrey's "not working either" (29 Aug) was a button that consumed the
       click and said nothing. A refusal the shopper cannot see is indistinguishable from a broken
       button; say why, and scroll it into view. */
    if (Core.getPriceAuthority() !== 'runtime') {
      el.atcHint.textContent = 'Live pricing hasn’t loaded, so we can’t take this to checkout yet. Refresh the page — your design is saved.';
      jumpTo('[data-summary-card]');
      return;
    }
    [el.atc, el.stickyAtc].forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
    var addingOpened = false; /* V9.28.162: set when this add told the drawer to open early */
    /* V9.28.119: the gift wrap row (same as the product pages) adds its wrap on this add's variant:add, if ticked */
    document.dispatchEvent(new CustomEvent('mes-gw:arm'));
    resolveVariant(price.bucket).then(function (variantId) {
      if (!variantId) {
        [el.atc, el.stickyAtc].forEach(function (b) { b.removeAttribute('aria-busy'); });
        el.atcHint.textContent = 'Almost there — cart opens when this product goes live. Your design autosaves, and Share keeps a link to it.';
        return Promise.reject('no-variant');
      }
      /* V9.28.101 (Shrey, 28 Sep; H411): the order line carries the DESIGN (`_build`) and no link. The production team
         opens the sheet from Mesmerize OS > Operations > Production, which lists pending custom bracelets from `_build`
         and opens `/products/custom-bracelet?view=production&<_build>`. The `_preview` link that used to sit on the
         line (V9.22.14) is gone; orders placed before this keep theirs. The sheet page itself is unchanged. */
      var build = Core.encodeBuild(st);
      /* V9.28.122 (Shrey, 30 Sep): the production-sheet LINK is BACK on the line as `_preview`, reversing the note
         above: hidden from the shopper, shown in the Shopify admin order, so anyone holding the order can open the
         exact bracelet without Mesmerize OS. Same string as `_build`, just addressable; no image is generated or stored. */
      var previewUrl = location.origin + '/products/' + (cfg.productHandle || 'custom-bracelet') + '?view=production&' + build;
      /* V9.28.109 (Shrey, 28 Sep): the BOX as a readable line, FIRST, because packing is a separate step done from the
         Shopify admin order, where `_build` is unreadable. Visible (no underscore) on purpose: admin shows it under the
         line item, and the shopper sees the same line in the cart and checkout. "Black Box" is the packers' word for
         the builder's "Signature Box". */
      var payload = { items: [{ id: Number(variantId), quantity: 1, properties: {
        Box: st.box === 'luxury' ? 'Luxury Box' : 'Black Box',
        _build: build,
        _preview: previewUrl,
        _mes_source: 'bracelet-builder'
      } }] };
      /* ⛔ THE DRAWER OPENS ON `variant:add`, NOT ON `cart:refresh` — Priyanka, 2 Sep: "unlike the
         other product pages, after adding this custom bracelet the cart drawer does NOT open
         automatically". `cart:refresh` only re-renders a drawer that is ALREADY open, which is why
         the item appeared correctly and nothing came forward. CartDrawer._onVariantAdded, bound to
         `variant:add` at theme.js.liquid:1891, is the one that calls show().
         So this now follows the theme's own add contract verbatim (theme.js.liquid:5111-5232):
           1. collect the sections to bundle, letting every listener add its own
           2. POST cart/add.js WITH those sections, so the response carries fresh renders
           3. read cart.js and hang the rendered sections off it
           4. dispatch `variant:add` — this is what OPENS the drawer
           5. dispatch `cart:change` with baseEvent 'variant:add' — this is what FILLS it
         ⛔ Both events are required and they are not interchangeable: one opens, one paints. */
      var root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
      var sections = ['variant-added'];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true, detail: { sections: sections }
      }));
      /* V9.28.162 (Shrey approved, 6 Oct): step 3 above no longer costs a second request. The add also asks
         for `mes-cart-json` and the cart is read out of its own response (theme.js window.MesCartJson, from
         api.js.liquid cartAfterAdd); without that helper, or with an unusable section, the cart.js read runs
         as before. And the drawer opens the moment the add starts (`mes-cart:adding`), with an "Adding…" pill
         that the cart:change of step 5 clears; a failure clears it via `mes-cart:add-failed` below. */
      var mcj = window.MesCartJson;
      if (mcj) { mcj.withSection(sections); }
      payload.sections = sections.join(',');
      payload.sections_url = location.pathname;
      if (!(window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.cartType === 'page')) {
        addingOpened = true;
        document.documentElement.dispatchEvent(new CustomEvent('mes-cart:adding', { bubbles: true, detail: { blockCartDrawerOpening: false } }));
      }
      return fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(payload)
      }).then(function (r) {
        if (mcj) { mcj.invalidate(); }
        if (!r.ok) { throw new Error('add failed'); }
        return r.json().then(function (added) {
          if (mcj) {
            return mcj.afterAdd(added).then(function (cart) { return { added: added, cart: cart }; });
          }
          return fetch(root + 'cart.js').then(function (c) { return c.json(); }).then(function (cart) {
            cart.sections = added.sections;
            return { added: added, cart: cart };
          });
        });
      });
    }).then(function (res) {
      if (!res) { return; }
      [el.atc, el.stickyAtc].forEach(function (b) { b.removeAttribute('aria-busy'); });
      /* the cart page has no drawer to open — go there, exactly as the theme's form does */
      if (window.themeVariables && window.themeVariables.settings
          && window.themeVariables.settings.cartType === 'page') {
        window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
        return;
      }
      document.documentElement.dispatchEvent(new CustomEvent('variant:add', {
        bubbles: true,
        detail: {
          items: res.added.hasOwnProperty('items') ? res.added.items : [res.added],
          cart: res.cart
        }
      }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true, detail: { baseEvent: 'variant:add', cart: res.cart }
      }));
      el.atcHint.textContent = 'Added — your bracelet is in the cart.';
    }).catch(function (e) {
      [el.atc, el.stickyAtc].forEach(function (b) { b.removeAttribute('aria-busy'); });
      if (addingOpened) { document.documentElement.dispatchEvent(new CustomEvent('mes-cart:add-failed', { bubbles: true })); }
      if (e !== 'no-variant') { el.atcHint.textContent = 'That didn’t go through — please try again.'; }
    });
  }

  /* the 766 bucket variants are PRE-PRICED, so the bucket IS the lookup key: match by price
     against the product's own JSON (fetched once, cached). VARIANT_MAP stays as an override.
     While the product is DRAFT the endpoint 404s and this resolves null — the honest hint. */
  /* ---------------------------------------------- the bucket → variant-id map (H297, Jeff)
     Loaded from the shop metafield rendered above. THREE tiers, in this order:
       1. the section-setting override (VARIANT_MAP) — manual escape hatch, normally empty
       2. the metafield map, IF its band stamp matches the band we compute from the catalogue
       3. matching the variant BY PRICE against the product's own JSON — cannot desync
     ⛔ Tier 2 is a CACHE. Jeff's own caveat is the reason: "a runtime source of truth that
     nothing keeps in sync". So it declares the band it was generated for, and a mismatch
     demotes it to tier 3 rather than selling against a stale id. A stale map costs one
     request; it never costs a wrong price. */
  var mapRaw = readJSON('[data-mzbb-variantmap="' + SID + '"]');
  var MAP = null, mapState = null;
  /* ⛔ RESOLVED LAZILY, ON FIRST USE — never at load. The stamp is checked against Core.band(),
     and band() reads the CATALOGUE's prices, which applyRuntime() rewrites from the runtime
     metafield later in this file. Checking at load would compare Jeff's map (built from live
     prices) against the SNAPSHOT band, mismatch on nearly every load, and silently demote a
     perfectly good map to the slow path forever — passing, while never doing its job. */
  function variantMap() {
    if (mapState) { return MAP; }
    if (!mapRaw) { mapState = 'absent'; return null; }
    /* accept a bare {bucket:id} map or a stamped {band:{…}, map:{…}} envelope */
    var m = (mapRaw.map && typeof mapRaw.map === 'object') ? mapRaw.map : mapRaw;
    if (!m || typeof m !== 'object' || !Object.keys(m).length) { mapState = 'empty'; return null; }
    var stamp = mapRaw.band;
    if (!stamp) { mapState = 'unstamped'; MAP = m; return MAP; }
    var live = Core.band();
    /* ⛔ band() returns minBucket/maxBucket/variantCount. Reading .min/.max/.count off it gives
       undefined, every comparison mismatches, and the map is condemned as stale on every load —
       a check that fails safe is still a check that never runs. Accept either spelling from the
       metafield so the stamp Jeff writes cannot be wrong on a naming detail. */
    var sMin = stamp.minBucket != null ? stamp.minBucket : stamp.min;
    var sMax = stamp.maxBucket != null ? stamp.maxBucket : stamp.max;
    var sCount = stamp.variantCount != null ? stamp.variantCount : stamp.count;
    if (live && (live.minBucket !== sMin || live.maxBucket !== sMax || live.variantCount !== sCount)) {
      mapState = 'stale';
      if (window.console) {
        console.warn('[mzbb] variant map is STALE — built for band ' + sMin + '–' + sMax + ' (' + sCount +
          '), catalogue now ' + live.minBucket + '–' + live.maxBucket + ' (' + live.variantCount +
          '). Each id from it is price-checked before use; ask store-data to regenerate custom.bracelet_variant_map.');
      }
      /* V9.28.128: a band mismatch no longer throws the map away. Tier 3 reads /products/<handle>.js, which
         returns only the first 250 variants (measured 30 Sep: 250 of 766), so above ₹7,475 it found nothing
         and Add to Cart died. The map is kept as UNVERIFIED and resolveVariant() confirms each id's price
         against /variants/<id>.js before using it: still one request, still never a wrong price. */
      MAP = m;
      return MAP;
    }
    mapState = 'ok'; MAP = m; return MAP;
  }
  function variantMapState() { variantMap(); return mapState; }

  var productJson = null;
  function resolveVariant(bucket) {
    /* ⛔ Jeff's correctness note, made a guard rather than a comment: the keys are the ₹25
       BUCKET, never the true computed total. Looking up an unrounded total misses every time
       and add-to-cart would do nothing, silently — the exact failure this whole page's price
       rules exist to prevent. A non-bucket reaching here is a bug upstream, so it is loud. */
    if (typeof bucket !== 'number' || !isFinite(bucket) || bucket % 25 !== 0) {
      if (window.console) { console.error('[mzbb] resolveVariant needs a ₹25 bucket, got: ' + bucket); }
      return Promise.resolve(null);
    }
    var key = String(bucket);
    if (VARIANT_MAP[key]) { return Promise.resolve(VARIANT_MAP[key]); }
    var mp = variantMap();
    var byPrice = function () { return tier3(bucket); };
    if (mp && mp[key]) {
      if (mapState !== 'stale') { return Promise.resolve(mp[key]); }
      var cand = mp[key];
      return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'variants/' + cand + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (v) { return (v && v.price === bucket * 100) ? cand : byPrice(); })
        .catch(byPrice);
    }
    return byPrice();
  }
  function tier3(bucket) {
    var handle = cfg.productHandle || 'custom-bracelet';
    var load = productJson ? Promise.resolve(productJson)
      : fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'products/' + handle + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (j) { productJson = j; return j; })
          .catch(function () { return null; });
    return load.then(function (j) {
      if (!j || !j.variants) { return null; }
      var paise = bucket * 100;
      var hit = j.variants.filter(function (v) { return v.price === paise && v.available !== false; })[0]
        || j.variants.filter(function (v) { return v.price === paise; })[0];
      return hit ? hit.id : null;
    });
  }

  /* --------------------------------------------------- controls — design styles, verbatim */
  function renderControls() {
    var isMag = st.construction !== 'elastic';
    var fin = hardware(st.color, st.surface);
    var canUndo = history.length > 0;
    var anyPlaced = st.beads.some(Boolean);
    var emptyLeft = st.beads.some(function (b) { return !b; });

    /* mirror chip */
    css(el.mirror, {
      display: 'flex', alignItems: 'center', gap: '5px', padding: '5px 10px',
      borderRadius: '100px', fontSize: '10.5px', fontWeight: '700', whiteSpace: 'nowrap', flexShrink: '0',
      background: st.mirror ? ACCENT : '#F4F0E2', color: st.mirror ? '#fff' : '#6E737A',
      border: '1px solid ' + (st.mirror ? ACCENT : '#DCD6C0'),
      boxShadow: st.mirror ? '0 1px 3px rgba(93,139,215,0.35)' : 'none',
      transition: 'all .2s ease', cursor: 'pointer'
    });
    el.mirror.setAttribute('aria-pressed', st.mirror ? 'true' : 'false');
    el.mirrorLabel.textContent = 'Mirror · ' + (st.mirror ? 'on' : 'off');
    el.mirrorask.hidden = !(st.mirrorAsk && st.mirror && !st.pickRemove);

    /* undo + auto-fill states */
    el.undo.disabled = !canUndo;
    css(el.undo, {
      width: '26px', height: '26px', flexShrink: '0', borderRadius: '50%', padding: '0',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      color: canUndo ? '#3C6BB8' : '#B9BCC1',
      border: '1px solid ' + (canUndo ? 'rgba(93,139,215,0.4)' : 'rgba(0,0,0,0.09)'),
      background: canUndo ? 'rgba(93,139,215,0.08)' : 'rgba(0,0,0,0.02)',
      cursor: canUndo ? 'pointer' : 'default'
    });
    el.undocap.style.color = canUndo ? '#8AA6D6' : '#C8CBD0';
    var afOn = anyPlaced && emptyLeft;
    el.autofill.disabled = !afOn;
    css(el.autofill, {
      display: 'flex', alignItems: 'center', gap: '5px', padding: '6px 12px', borderRadius: '100px',
      fontSize: '10.5px', fontWeight: '700', whiteSpace: 'nowrap', flexShrink: '0',
      border: '1px solid ' + (afOn ? ACCENT : '#DCD6C0'),
      color: afOn ? ACCENT : '#A2A6AC',
      background: afOn ? 'rgba(93,139,215,0.07)' : '#F4F0E2',
      cursor: afOn ? 'pointer' : 'default', transition: 'all .2s ease'
    });

    /* start-with-a-design caret + row */
    el.startcaret.style.transform = st.startOpen ? 'rotate(90deg)' : 'rotate(0deg)';
    el.startopen.hidden = !st.startOpen;

    /* sort pills + slider */
    var SORT_ORDER = ['intent', 'color', 'price'];
    var SORT_W = { intent: 108, color: 94, price: 88 };
    var si = SORT_ORDER.indexOf(st.sort);
    css(el.sortslider, { width: SORT_W[st.sort] + 'px', opacity: '1', transform: 'translateX(' + (si * 26) + 'px)' });
    $$('[data-mzbb-sort]').forEach(function (b) {
      var mode = b.getAttribute('data-mzbb-sort');
      var on = st.sort === mode;
      css(b, {
        position: 'relative', zIndex: '1', display: 'flex', alignItems: 'center', justifyContent: 'center',
        gap: on ? '5px' : '0', flexDirection: 'row-reverse',
        width: (on ? SORT_W[mode] : 26) + 'px', height: '22px', padding: '0', borderRadius: '100px', flexShrink: '0',
        color: on ? '#fff' : '#6E737A', background: 'transparent', border: 'none', cursor: 'pointer',
        transition: 'width .26s cubic-bezier(.4,0,.2,1), color .18s ease'
      });
      var txt = b.querySelector('[data-sorttxt]');
      css(txt, { fontSize: '10px', fontWeight: '600', whiteSpace: 'nowrap', lineHeight: '1', maxWidth: on ? '76px' : '0', opacity: on ? '1' : '0', overflow: 'hidden', transition: 'max-width .26s cubic-bezier(.4,0,.2,1), opacity .18s ease' });
      var icons = b.querySelector('[data-sorticons]');
      css(icons, { display: 'flex', alignItems: 'center', gap: on ? '1px' : '0' });
      var arrow = b.querySelector('[data-sortarrow]');
      var arrowOn = on && mode !== 'intent';
      css(arrow, { display: 'block', width: arrowOn ? '9px' : '0', opacity: arrowOn ? '1' : '0', overflow: 'hidden', transform: st.sortDesc ? 'scaleY(-1)' : 'none', transition: 'width .26s cubic-bezier(.4,0,.2,1), opacity .18s ease, transform .22s cubic-bezier(.4,0,.2,1)' });
    });

    /* luxury chip — foil text off, foil fill on */
    var lux = st.luxOnly;
    css(el.lux, {
      padding: '7px 13px', borderRadius: '100px', fontSize: '11px', fontWeight: '700',
      color: lux ? '#FDFCF6' : '#6E737A',
      background: lux ? FOIL : '#F4F0E2', backgroundSize: lux ? '260px 100%' : '',
      animation: lux ? 'mzFoil 7s linear infinite' : 'none',
      border: '1px solid ' + (lux ? '#B98A1E' : '#E3CD93'), transition: 'border-color .2s ease', cursor: 'pointer'
    });
    el.lux.setAttribute('aria-pressed', lux ? 'true' : 'false');
    if (lux) { css(el.luxlabel, { color: '#15171A', fontWeight: '700', background: 'none', webkitTextFillColor: '' }); }
    else {
      css(el.luxlabel, {
        background: 'repeating-linear-gradient(105deg,#8A5F12,#B98A1E 40px,#E8C255 74px,#F3D77E 94px,#B98A1E 128px,#8A5F12 175px)',
        backgroundSize: '180px 100%', webkitBackgroundClip: 'text', backgroundClip: 'text',
        color: 'transparent', webkitTextFillColor: 'transparent', fontWeight: '700', animation: 'mzFoilTxt 3.4s linear infinite'
      });
    }

    /* sizes — GLASS pills */
    el.sizes.textContent = '';
    Core.catalogue.sizes.forEach(function (z) {
      var on = st.size === z.id && !st.sizeAuto;
      var b = document.createElement('button');
      b.type = 'button'; b.textContent = z.id;
      /* V9.28.114 (Shrey, 28 Sep 2026): the typical wrist size under each button, like the product pages */
      if (SIZE_SHOW[z.id]) {
        var cap = document.createElement('span');
        cap.textContent = SIZE_SHOW[z.id] + ' cm';
        css(cap, { display: 'block', marginTop: '3px', fontSize: '10.5px', fontWeight: '600', letterSpacing: '.01em',
          lineHeight: '1', color: on ? ACCENT : '#2D3035', opacity: on ? '1' : '.74' });
        b.appendChild(cap);
      }
      css(b, Object.assign({
        /* ⛔ explicit centring: the theme's global button rules flatten these to
           display:block / text-align:start, so the label sat hard left (Shrey, 30 Aug). */
        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center',
        width: '58px', minHeight: '46px', padding: '7px 4px', lineHeight: '1.05', borderRadius: '12px', fontSize: '14px',
        fontWeight: on ? '700' : '500', color: on ? ACCENT : '#2D3035',
        transform: on ? 'scale(1.06)' : 'none', transition: 'all .2s ease', cursor: 'pointer'
      }, on ? GLASS_ON : GLASS));
      b.addEventListener('click', function () { pickSize(z.id); });
      el.sizes.appendChild(b);
    });
    var zdef = st.size && !st.sizeAuto ? Core.sizeRow(st.size) : null;
    el.sizehead.textContent = zdef ? st.size + ' · ' + zdef.wristCm + ' cm' : 'not set';
    el.sizehead.style.color = zdef ? ACCENT : '#A2A6AC';
    /* the product page's link: ruler icon + Size guide / Hide guide */
    el.guide.innerHTML = GUIDE_ICON + (st.guideOpen ? 'Hide guide' : 'Size guide');
    el.guide.setAttribute('aria-expanded', st.guideOpen ? 'true' : 'false');
    renderSizeWarn();
    renderGuide();

    /* closure cards + finish row */
    el.magprice.textContent = '+' + money(HW.closures.magsnap.priceINR);
    el.elasticprice.textContent = '+' + money(HW.closures.elastic.priceINR);
    el.buildhead.textContent = st.construction ? (isMag && st.construction ? 'MagSnap 4 · ' + fin.label : 'Elastic') : 'not set';
    el.buildhead.style.color = st.construction ? ACCENT : '#A2A6AC';
    $$('[data-mzbb-closure]').forEach(function (b) {
      var kind = b.getAttribute('data-mzbb-closure');
      b.hidden = !Core.isOn(kind);
      var on = st.construction === kind;
      css(b, Object.assign({ transform: on ? 'scale(1.02)' : 'none', transition: 'all .2s ease' }, on ? Object.assign({}, GLASS, GLASS_ON) : GLASS));
    });
    el.finish.hidden = !(st.construction === 'magsnap');
    el.finishrow.textContent = '';
    /* V9.28.125: a surface the CURRENT colour cannot have (owner switch "black-gloss") is not offered; tapping a colour
       whose pair is off flips the surface in normalise(). */
    [['gloss', 'Gloss'], ['matte', 'Matte']].filter(function (sdef) { return Core.isOn(sdef[0]) && Core.finishOn(st.color, sdef[0]); }).forEach(function (sdef) {
      var on = st.surface === sdef[0];
      var b = document.createElement('button');
      b.type = 'button'; b.textContent = sdef[1];
      css(b, Object.assign({ padding: '12px 15px', borderRadius: '100px', fontSize: '11.5px', whiteSpace: 'nowrap', fontWeight: on ? '700' : '500', color: on ? ACCENT : '#2D3035', transition: 'all .2s ease', cursor: 'pointer' }, on ? GLASS_ON : GLASS));
      b.addEventListener('click', function () { set({ surface: sdef[0] }); primeClaspAspect(); });
      el.finishrow.appendChild(b);
    });
    var sepr = document.createElement('span');
    css(sepr, { width: '1px', height: '22px', background: '#ECE7D6', margin: '0 3px', display: 'block' });
    el.finishrow.appendChild(sepr);
    Object.keys(COLORS).filter(function (id) { return Core.isOn(id); }).forEach(function (id) {
      var on = st.color === id;
      var h = hardware(id, st.surface);
      var hit = document.createElement('button');
      hit.type = 'button'; hit.title = COLORS[id].name; hit.setAttribute('aria-label', COLORS[id].name);
      css(hit, { width: '50px', height: '44px', flexShrink: '0', padding: '0', borderRadius: '100px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', border: '0', background: 'none' });
      var disc = document.createElement('span');
      css(disc, {
        display: 'block', width: '38px', height: '28px', flexShrink: '0', borderRadius: '100px',
        background: h.discBg,
        boxShadow: on ? h.discShadow + ', 0 0 0 2px #5d8bd7, 0 0 0 5px rgba(93,139,215,0.16)' : h.discShadow,
        transform: on ? 'scale(1.06)' : 'none', transition: 'transform .18s ease, box-shadow .18s ease'
      });
      hit.appendChild(disc);
      hit.addEventListener('click', function () { set({ color: id }); primeClaspAspect(); });
      el.finishrow.appendChild(hit);
    });

    renderCentre();
    renderBoxes();
  }

  /* size warning — design markup with both resize paths */
  function renderSizeWarn() {
    var on = !!st.sizeAsk || (!!st.resizeDone && !st.pickRemove);
    el.sizewarn.hidden = !on;
    if (!on) { return; }
    var id = st.sizeAsk || (st.resizeDone && st.resizeDone.id) || st.size;
    var z = Core.sizeRow(id);
    if (!z) { el.sizewarn.hidden = true; return; }
    var resizeOn = !!st.resizeDone && !st.pickRemove;
    el.sizewarn.innerHTML =
      '<div style="margin-top:12px; padding:13px 14px; border-radius:12px; border:1px solid rgba(176,141,42,0.45); background:rgba(230,185,60,0.15);">' +
      '<div style="display:flex; gap:9px; align-items:flex-start;">' +
      '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#9A7B1E" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="flex-shrink:0; margin-top:1px;"><path d="m21.7 18-8-14a2 2 0 0 0-3.5 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.7-3Z"></path><path d="M12 9v4"></path><path d="M12 17h.01"></path></svg>' +
      '<div style="flex:1; min-width:0;">' +
      '<div style="font-size:12.5px; font-weight:700; color:#15171A;">Size ' + z.id + ' fits ' + z.wristCm + ' cm wrists (' + z.wristIn + ').</div>' +
      '<div style="font-size:11.5px; color:#6E737A; line-height:1.55; margin-top:3px;">Please double-check the size that best fits you, since this bracelet will be made just for you.</div>' +
      (resizeOn ? '<div style="font-size:11.5px; font-weight:600; color:#8F6E1F; line-height:1.5; margin-top:5px;">Removed ' + st.resizeDone.drop + (st.resizeDone.drop === 1 ? ' bead' : ' beads') + ' to fit size ' + st.resizeDone.id + '.</div>' : '') +
      '</div></div>' +
      '<div style="display:flex; gap:7px; margin-top:10px; flex-wrap:wrap;">' +
      (resizeOn
        ? '<button type="button" data-w="undo" style="min-height:34px; padding:8px 13px; border-radius:100px; border:1px solid #9A7B1E; color:#8F6E1F; font-size:11.5px; font-weight:700; background:#fff; cursor:pointer;">Undo</button>' +
          '<button type="button" data-w="pick" style="min-height:34px; padding:8px 13px; border-radius:100px; border:0; background:#9A7B1E; color:#fff; font-size:11.5px; font-weight:700; cursor:pointer;">I\'ll pick the beads</button>'
        : '') +
      '<button type="button" data-w="guide" style="min-height:34px; padding:8px 13px; border-radius:100px; border:1px solid #DCD6C0; color:#2D3035; font-size:11.5px; font-weight:600; background:#F4F0E2; cursor:pointer;">How to measure</button>' +
      '<button type="button" data-w="ok" style="min-height:34px; padding:8px 13px; border-radius:100px; border:0; background:none; color:#6E737A; font-size:11.5px; font-weight:600; cursor:pointer;">Got it</button>' +
      '</div></div>';
    el.sizewarn.querySelectorAll('[data-w]').forEach(function (b) {
      b.addEventListener('click', function () {
        var w = b.getAttribute('data-w');
        if (w === 'ok') { set({ sizeAsk: null, resizeDone: null }, { silent: true }); }
        else if (w === 'guide') { set({ guideOpen: true }, { silent: true }); }
        else if (w === 'undo') {
          var rd = st.resizeDone; if (!rd) { return; }
          set({ beads: rd.prevBeads.slice(), size: rd.prevSize, resizeDone: null, sizeAsk: null, pickRemove: 0, active: -1 });
        } else if (w === 'pick') {
          var rd2 = st.resizeDone; if (!rd2) { return; }
          set({ beads: rd2.prevBeads.slice(), size: rd2.prevSize, resizePrompt: { to: rd2.id }, resizeDone: null, sizeAsk: null, pickRemove: rd2.drop, active: -1 });
        }
      });
    });
  }

  /* V9.28.113 (Shrey, 28 Sep 2026): the size guide is the PRODUCT PAGE's guide, opening in place under the
     size buttons (snippets/mes-sg2-wrist: slider + drawing, flip to the chart). It replaced this file's own
     chart and how-to-measure faces, so the builder, the Zodiac page and every product page match.
     st.guideOpen stays the source of truth for the link label and the "Size guide" warning button. */
  function renderGuide() {
    el.guidebody.hidden = true;
    if (!el.sg2 || !el.sg2.toggle) { return; }
    if (el.sg2.open !== st.guideOpen) { el.sg2.toggle(st.guideOpen); }
    if (st.size) { el.sg2.setSize(st.size); }
  }

  /* centre piece: tabs + charm grid + cube card — design markup, exclusivity via normalise */
  function renderCentre() {
    el.centretabs.textContent = '';
    [['core', 'Core'], ['silver', '925 Silver'], ['cube', 'Initials']].filter(function (t) {
      if (t[0] === 'cube') { return Core.isOn('cube'); }
      return (HW.charms || []).some(function (c) { return c.tab === t[0] && Core.isOn(c.id); });
    }).forEach(function (t) {
      var on = st.centreMode === t[0] || (t[0] === 'cube' && st.centreMode === 'personalised');
      var b = document.createElement('button');
      b.type = 'button'; b.textContent = t[1];
      css(b, Object.assign({ padding: '7px 13px', borderRadius: '100px', fontSize: '11px', fontWeight: on ? '700' : '500', color: on ? ACCENT : '#6E737A', background: on ? '' : '#F4F0E2', border: on ? '' : '1px solid #ECE7D6', cursor: 'pointer' }, on ? GLASS_ON : {}));
      b.addEventListener('click', function () { set({ centreMode: t[0] }, { silent: true }); });
      el.centretabs.appendChild(b);
    });
    var showCube = st.centreMode === 'cube' || st.centreMode === 'personalised';
    el.charmgrid.hidden = showCube;
    el.cubecard.hidden = !showCube;
    if (!showCube) {
      el.charmgrid.textContent = '';
      var sil = hardware('silver', st.surface);
      var list = [{ id: 'none', name: 'None', price: 0, tab: 'any' }].concat((HW.charms || []).filter(function (c) { return c.tab === st.centreMode && Core.isOn(c.id); }));
      list.forEach(function (c) {
        var on = c.id === 'none' ? (st.charm === 'none' && !st.cubeOn) : st.charm === c.id;
        var b = document.createElement('button');
        b.type = 'button';
        css(b, { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '6px', position: 'relative', border: '0', background: 'none', padding: '0', cursor: 'pointer' });
        var disc = document.createElement('span');
        css(disc, {
          position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center',
          width: '50px', height: '50px', borderRadius: '50%', overflow: 'hidden',
          background: c.img ? 'url(' + c.img + '&width=180) center/100% no-repeat' : c.id === 'none' ? '#F4F0E2' : sil.discBg,
          border: c.id === 'none' ? '1px dashed #DCD6C0' : 'none',
          boxShadow: c.id === 'none'
            ? (on ? '0 0 0 2px ' + ACCENT + ', inset 0 2px 7px rgba(0,0,0,.09), inset 0 1px 2px rgba(0,0,0,.06)' : 'inset 0 2px 7px rgba(0,0,0,.09), inset 0 1px 2px rgba(0,0,0,.06), 0 1px 0 rgba(255,255,255,.72)')
            : c.img ? (on ? '0 5px 14px rgba(30,28,22,0.26), 0 0 0 2px ' + ACCENT : 'none')
            : on ? '0 0 0 2px ' + ACCENT + ', 0 6px 14px rgba(0,0,0,0.16)' : sil.discShadow,
          transform: on ? 'scale(1.06)' : 'none', transition: 'all .2s ease'
        });
        b.appendChild(disc);
        var lbl = document.createElement('span');
        lbl.textContent = c.name;
        css(lbl, { display: 'block', fontSize: '11px', fontWeight: on ? '700' : '500', color: on ? ACCENT : '#2D3035', textAlign: 'center' });
        b.appendChild(lbl);
        var pr = document.createElement('span');
        pr.textContent = c.priceINR ? '+' + money(c.priceINR) : 'Included';
        css(pr, { display: 'block', fontSize: '9.5px', color: '#A2A6AC' });
        b.appendChild(pr);
        b.addEventListener('click', function () { set({ charm: c.id, _lastCentre: 'charm' }); });
        el.charmgrid.appendChild(b);
      });
    } else {
      var cm = CUBE_METAL[st.cubeMetal || 'silver'];
      var canCube = !!(st.initials || '').length;
      var cardHtml =
        '<div style="margin-top:12px; padding:14px; border-radius:14px; border:1px solid rgba(255,255,255,0.6); background:linear-gradient(160deg,rgba(253,252,246,0.72),rgba(244,240,226,0.55)); box-shadow:0 4px 18px rgba(0,0,0,0.06), inset 0 1px 0 rgba(255,255,255,0.7); display:flex; gap:14px; align-items:flex-start;">' +
        '<div style="display:flex; flex-direction:column; align-items:center; gap:9px; flex-shrink:0;">' +
        '<div data-cubepreview style="width:50px; height:50px; flex-shrink:0; border-radius:12px; background:linear-gradient(115deg, rgba(255,255,255,0) 38%, rgba(255,255,255,0.28) 41%, rgba(255,255,255,0.82) 47%, rgba(255,255,255,0.28) 53%, rgba(255,255,255,0) 56%), ' + cm.grad + '; box-shadow:inset 0 1px 0 rgba(255,255,255,0.95), inset 0 -2px 1px rgba(0,0,0,0.42), inset 2px 0 2px rgba(255,255,255,0.5), inset -2px 0 2px rgba(0,0,0,0.18), 0 3px 6px rgba(0,0,0,0.22), 0 1px 1px rgba(0,0,0,0.2); display:flex; align-items:center; justify-content:center; font-family:\'Jost\',\'Futura\',sans-serif; font-size:18px; font-weight:700; letter-spacing:0.04em; color:' + (st.cubeOn ? cm.etch : cm.etchOff) + ';">' + (st.initials || 'AB').toUpperCase() + '</div>' +
        '<input data-cubeinitials value="' + (st.initials || '') + '" placeholder="AB" maxlength="2" style="width:50px; padding:7px 6px; font-size:12.5px; font-weight:700; letter-spacing:0.08em; text-transform:uppercase; text-align:center; background:#FDFCF6; border:1px solid #DCD6C0; border-radius:10px; color:#15171A;">' +
        '</div>' +
        '<div style="flex:1; min-width:0; display:flex; flex-direction:column; gap:9px;">' +
        '<div style="display:flex; align-items:center; gap:7px; font-size:13px; font-weight:700; line-height:1;"><span style="color:' + ACCENT + ';">+' + money(HW.initialsCube.priceINR) + '</span><span style="color:#15171A;">Laser-etched hematite cube</span></div>' +
        '<div style="display:flex; gap:6px; align-items:center;">' +
        ['silver', 'gold'].map(function (mId) {
          var mOn = st.cubeMetal === mId;
          return '<button type="button" data-cubemetal="' + mId + '" style="display:flex; align-items:center; gap:6px; padding:6px 11px; border-radius:100px; font-size:11px; font-weight:' + (mOn ? 700 : 500) + '; color:' + (mOn ? ACCENT : '#6E737A') + '; ' + (mOn ? 'border:1px solid rgba(93,139,215,0.45); background:linear-gradient(160deg,rgba(253,252,246,0.78),rgba(93,139,215,0.12)); box-shadow:0 8px 16px rgba(0,0,0,0.12), inset 0 1px 0 rgba(255,255,255,0.8);' : 'background:#F4F0E2; border:1px solid #ECE7D6;') + ' cursor:pointer;"><span style="width:11px; height:11px; border-radius:3px; flex-shrink:0; background:' + CUBE_METAL[mId].grad + '; box-shadow:inset 0 1px 1px rgba(255,255,255,0.7);"></span>' + CUBE_METAL[mId].label + '</button>';
        }).join('') +
        '<button type="button" data-cubetoggle style="margin-left:auto; padding:8px 13px; border-radius:100px; font-size:11.5px; font-weight:600; white-space:nowrap; flex-shrink:0; background:' + (st.cubeOn ? ACCENT : canCube ? 'rgba(93,139,215,0.06)' : '#ECE7D6') + '; color:' + (st.cubeOn ? '#FDFCF6' : canCube ? ACCENT : '#A2A6AC') + '; border:1px solid ' + (st.cubeOn || canCube ? ACCENT : '#DCD6C0') + '; cursor:' + (st.cubeOn || canCube ? 'pointer' : 'not-allowed') + ';">' + (st.cubeOn ? 'Added, remove' : canCube ? 'Add cube' : 'Enter initials first') + '</button>' +
        '</div></div></div>';
      var bindToggle = function () {
        el.cubecard.querySelector('[data-cubetoggle]').addEventListener('click', function () {
          if (!st.cubeOn && !(st.initials || '').length) { return; }
          set({ cubeOn: !st.cubeOn, _lastCentre: 'cube' });
        });
      };
      /* V9.28.130 (Priyanka, 30 Sep: "the personalization block is glitching, I am not able to type anything"):
         every keystroke calls set() → render(), and this card was rebuilt with innerHTML each time, so the letters
         box was a NEW element after one key (measured: different node, focus on <body>) and the phone keyboard
         dropped. While the box is being typed in, it is left exactly where it is and only the two parts that
         depend on the letters (the cube preview and the Add/Remove button) are swapped in around it. */
      var liveInp = el.cubecard.querySelector('[data-cubeinitials]');
      if (liveInp && document.activeElement === liveInp) {
        var tmp = document.createElement('div');
        tmp.innerHTML = cardHtml;
        ['[data-cubepreview]', '[data-cubetoggle]'].forEach(function (sel) {
          var was = el.cubecard.querySelector(sel), now = tmp.querySelector(sel);
          if (was && now) { was.parentNode.replaceChild(now, was); }
        });
        bindToggle();
        return;
      }
      el.cubecard.innerHTML = cardHtml;
      var inp = el.cubecard.querySelector('[data-cubeinitials]');
      inp.addEventListener('input', function () {
        var v = inp.value.replace(/[^A-Za-z0-9]/g, '').slice(0, 2).toUpperCase();
        /* only rewrite the box when a character was actually removed: writing it back on every key breaks
           an Android keyboard's word-in-progress. Capitals come from CSS (text-transform). */
        if (inp.value.toUpperCase() !== v) { inp.value = v; }
        set({ initials: v, cubeOn: st.cubeOn && !!v.length, _lastCentre: 'cube' });
      });
      el.cubecard.querySelectorAll('[data-cubemetal]').forEach(function (b) {
        b.addEventListener('click', function () { set({ cubeMetal: b.getAttribute('data-cubemetal'), cubeOn: true, _lastCentre: 'cube' }); });
      });
      bindToggle();
    }
  }

  /* packaging — the design's box cards with the MESMERIZE chip lockup */
  function renderBoxes() {
    el.boxes.textContent = '';
    [['kappa', 'Signature Box', 'Included', 'Our signature black box, included with every build.'],
     ['luxury', 'Luxury Box', '+' + money(399), 'Rigid box with a hinge for a satisfying close. Designed for years of re-use.']].filter(function (bx) { return Core.isOn(bx[0]); }).forEach(function (bx) {
      var on = (st.box || 'kappa') === bx[0];
      var lux = bx[0] === 'luxury';
      var b = document.createElement('button');
      b.type = 'button';
      css(b, Object.assign({
        padding: '11px 12px 12px', borderRadius: '14px', display: 'flex', flexDirection: 'column',
        alignItems: 'center', gap: '8px', transition: 'all .2s ease',
        transform: on ? 'scale(1.02)' : 'none', cursor: 'pointer'
      }, on ? Object.assign({}, GLASS, GLASS_ON) : GLASS));
      b.innerHTML =
        /* ⛔ the lux box is a LONG flat box, so a stretch-to-fit width turns it into a letterbox
           strip as the column widens (Shrey, 29 Aug: "on desktop it's a bit too long"). Capped,
           centred, and given its height back by the desktop rule on [data-mzbb-boximg]. */
        '<span data-mzbb-boximg' + (lux ? ' data-lux' : '') + ' style="width:' + (lux ? '100%' : '68px') + '; max-width:' + (lux ? '210px' : 'none') + '; height:' + (lux ? '44px' : '68px') + '; align-self:center; border-radius:0; flex-shrink:0; display:flex; align-items:center; justify-content:center; border:' + (lux ? '4px solid #52381F' : '1px solid #000000') + '; background:' + (lux ? '#A9825A' : '#0D0D0F') + '; box-shadow:' + (lux ? 'inset 0 1px 2px rgba(255,255,255,0.28), inset 0 -3px 6px rgba(0,0,0,0.2)' : 'inset 0 1px 2px rgba(255,255,255,0.1), inset 0 -3px 8px rgba(0,0,0,0.5)') + ';">' +
        '<span style="display:flex; align-items:center; justify-content:center; padding:2px 3px; border:1px solid ' + (lux ? 'rgba(226,197,126,0.85)' : 'rgba(228,233,238,0.8)') + ';">' +
        '<span style="font-family:\'FF Clan Pro\',\'Futura\',sans-serif; font-weight:700; display:block; text-align:center; margin-right:-0.1em; font-size:4px; letter-spacing:0.1em; line-height:1; white-space:nowrap; background:' + (lux ? 'linear-gradient(105deg,#A87C28,#F4DC96 34%,#C89F41 56%,#FAEEBC 76%,#A2762A)' : 'linear-gradient(105deg,#8F979E,#FFFFFF 34%,#B9C1C8 56%,#F4F7F9 76%,#939BA2)') + '; -webkit-background-clip:text; background-clip:text; color:transparent;">MESMERIZE</span></span></span>' +
        '<span style="display:flex; align-items:baseline; justify-content:center; gap:6px; font-size:12.5px; font-weight:700; color:#15171A; white-space:nowrap;">' + bx[1] + ' <span style="font-size:11px; font-weight:700; color:' + (on ? ACCENT : '#6E737A') + ';">' + bx[2] + '</span></span>' +
        '<span style="display:block; font-size:10.5px; color:#6E737A; text-align:center; line-height:1.35;">' + bx[3] + '</span>';
      b.addEventListener('click', function () { set({ box: bx[0] }); });
      el.boxes.appendChild(b);
    });
  }

  /* presets row — the design's stone-dot chips */
  function renderPresets() {
    el.presetrow.textContent = '';
    /* V9.28.116: a preset that needs an out-of-stock stone or a switched-off centre piece is not offered */
    PRESETS.filter(function (p) {
      return p.stones.every(Core.stoneOk) && (!p.charm || p.charm === 'none' || Core.isOn(p.charm));
    }).forEach(function (p) {
      var b = document.createElement('button');
      b.type = 'button';
      css(b, Object.assign({
        display: 'flex', alignItems: 'center', gap: '8px', whiteSpace: 'nowrap',
        padding: '13px 16px 13px 10px', borderRadius: '100px', fontSize: '12px', fontWeight: '600', minHeight: '44px',
        color: '#2D3035', transition: 'all .2s ease', cursor: 'pointer'
      }, GLASS));
      var dots = document.createElement('span');
      css(dots, { display: 'flex', flexShrink: '0' });
      p.stones.forEach(function (id, i) {
        var s = BY_ID[id];
        var d = document.createElement('span');
        css(d, {
          display: 'block', width: '18px', height: '18px', borderRadius: '50%', flexShrink: '0',
          marginLeft: i ? '-6px' : '0', zIndex: String(3 - i),
          border: '1.5px solid #FDFCF6', position: 'relative',
          background: s && stoneImg(s, 60) ? 'url(' + stoneImg(s, 60) + ') center/100% no-repeat'
            : s ? 'radial-gradient(circle at 33% 27%, ' + s.highlightHex + ', ' + s.baseHex + ' 52%, rgba(0,0,0,0.72) 108%)' : '#DCD6C0'
        });
        dots.appendChild(d);
      });
      b.appendChild(dots);
      b.appendChild(document.createTextNode(p.name));
      b.addEventListener('click', function () { loadPreset(p); });
      el.presetrow.appendChild(b);
    });
  }

  /* -------------------------------------------------- grid: order · filter · truncate */
  function hexHue(hex) {
    var m = hex.replace('#', '');
    var r = parseInt(m.slice(0, 2), 16) / 255, g = parseInt(m.slice(2, 4), 16) / 255, b = parseInt(m.slice(4, 6), 16) / 255;
    var mx = Math.max(r, g, b), mn = Math.min(r, g, b);
    if (mx === mn) { return 0; }
    var h;
    if (mx === r) { h = ((g - b) / (mx - mn)) % 6; } else if (mx === g) { h = (b - r) / (mx - mn) + 2; } else { h = (r - g) / (mx - mn) + 4; }
    return (h * 60 + 360) % 360;
  }
  function orderedStones() {
    var rows = Core.inStockStones().slice();
    if (st.luxOnly) { rows = rows.filter(function (s) { return s.tier === 'luxury'; }); }
    if (st.sort === 'price') {
      rows.sort(function (a, b) { return (a.priceINR - b.priceINR) || a.name.localeCompare(b.name); });
      if (st.sortDesc) { rows.reverse(); }
    } else if (st.sort === 'color') {
      rows.sort(function (a, b) {
        var ha = COLOR_HEAD.indexOf(a.id), hb = COLOR_HEAD.indexOf(b.id);
        var ta = COLOR_TAIL.indexOf(a.id), tb = COLOR_TAIL.indexOf(b.id);
        var rank = function (h, t) { return h > -1 ? 0 : t > -1 ? 2 : 1; };
        var ra = rank(ha, ta), rb = rank(hb, tb);
        if (ra !== rb) { return ra - rb; }
        if (ra === 0) { return ha - hb; }
        if (ra === 2) { return ta - tb; }
        return hexHue(a.baseHex) - hexHue(b.baseHex);
      });
      var ids = COLOR_GREEN_BLUE.filter(function (id) { return rows.some(function (s) { return s.id === id; }); });
      if (ids.length) {
        var first = Math.min.apply(null, ids.map(function (id) { return rows.findIndex(function (s) { return s.id === id; }); }));
        var kept = rows.filter(function (s) { return ids.indexOf(s.id) < 0; });
        var ordered = ids.map(function (id) { return rows.filter(function (s) { return s.id === id; })[0]; });
        rows = kept.slice(0, first).concat(ordered, kept.slice(first));
      }
      var moved = [];
      COLOR_PRE_HEMATITE.forEach(function (id) {
        var i = rows.findIndex(function (s) { return s.id === id; });
        if (i > -1) { moved.push(rows.splice(i, 1)[0]); }
      });
      var at = rows.findIndex(function (s) { return s.id === 'greyhematite'; });
      if (at > -1) { rows.splice.apply(rows, [at, 0].concat(moved)); } else { rows = rows.concat(moved); }
      if (st.sortDesc) { rows.reverse(); }
    }
    return rows;
  }

  function renderGrid() {
    var tiles = {};
    $$('[data-mzbb-tile]').forEach(function (t) { tiles[t.getAttribute('data-stone')] = t; });
    var groups = $$('[data-mzbb-group]');
    var byIntent = st.sort === 'intent';
    var rows = orderedStones();
    var visible = {};
    rows.forEach(function (s) { visible[s.id] = true; });
    var cap = st.showAll ? Infinity : 16;
    var shown = 0, hiddenCount = 0;
    groups.forEach(function (g) {
      var heading = g.querySelector('[data-groupheading]');
      var wrap = g.querySelector('[data-grouptiles]');
      if (byIntent) { g.style.display = ''; heading.style.display = ''; wrap.style.display = 'grid'; }
      else { heading.style.display = 'none'; g.style.display = 'contents'; wrap.style.display = 'contents'; }
    });
    if (!byIntent) {
      /* flat sorted list: one shared grid via CSS order on a single wrapping grid */
      el.grid.style.display = 'grid';
      el.grid.style.gridTemplateColumns = 'repeat(4,1fr)';
      el.grid.style.gap = '12px 10px';
      rows.forEach(function (s, i) { if (tiles[s.id]) { tiles[s.id].style.order = String(i); } });
    } else {
      el.grid.style.display = '';
      el.grid.style.gridTemplateColumns = '';
      el.grid.style.gap = '';
      Object.keys(tiles).forEach(function (id) { tiles[id].style.order = ''; });
    }
    var seq = byIntent ? $$('[data-mzbb-tile]').map(function (t) { return t.getAttribute('data-stone'); }) : rows.map(function (s) { return s.id; });
    seq.forEach(function (id) {
      var t = tiles[id];
      if (!t) { return; }
      var ok = !!visible[id];
      if (ok && shown < cap) { t.hidden = false; shown++; }
      else { t.hidden = true; if (ok) { hiddenCount++; } }
    });
    /* ⛔ V9.28.118 (Shrey, 29 Sep: "in the color and price sort, the luxury filter is not working"). In those two
       orders `seq` holds only the FILTERED stones, so a tile the filter dropped was never visited and kept whatever
       state it had: Luxury on showed 31 tiles, 16 of them ordinary stones left over from before, and their stale
       CSS order scrambled the price order too. Every tile outside the current list is hidden explicitly. */
    Object.keys(tiles).forEach(function (id) { if (!visible[id]) { tiles[id].hidden = true; } });
    if (byIntent) {
      groups.forEach(function (g) {
        var any = Array.prototype.some.call(g.querySelectorAll('[data-mzbb-tile]'), function (t) { return !t.hidden; });
        g.style.display = any ? '' : 'none';
      });
    }
    /* prices + selected ring from the runtime catalogue.
       ⛔ Shrey, 29 Aug: "after picking a preset, the highlight on the stone selection neither
       comes". A preset sets active:-1 (so the ring keeps showing "Protection loaded" rather than
       a bead name), and the highlight was bound to the ACTIVE bead alone - so a loaded design
       showed nothing selected and read as if nothing had happened. Two strengths now: the active
       bead's stone keeps the strong ring, and every stone PRESENT IN THE BUILD gets a soft one,
       so a preset immediately shows which stones it is made of. */
    var inBuild = {};
    st.beads.forEach(function (b) { if (b) { inBuild[b] = 1; } });
    $$('[data-mzbb-tile]').forEach(function (t) {
      var id = t.getAttribute('data-stone');
      var s = BY_ID[id];
      var p = t.querySelector('[data-mzbb-tileprice]');
      if (s && p) { p.textContent = money(s.priceINR); }
      var dot = t.querySelector('[data-tiledot]');
      if (!dot) { return; }
      var on = st.active > -1 && st.beads[st.active] === id;
      var used = !on && !!inBuild[id];
      dot.style.transform = on ? 'scale(1.07)' : used ? 'scale(1.03)' : 'none';
      dot.style.outline = on ? '1.5px solid rgba(93,139,215,0.55)'
        : used ? '1.5px solid rgba(93,139,215,0.28)' : 'none';
      dot.style.outlineOffset = (on || used) ? '1.5px' : '0';
    });
    /* Show more/fewer — design's GLASS pill */
    var total = rows.length;
    /* H539: the hero stat is the same live count as this button (switched-on stones, before the Luxury filter) */
    var statEl = document.querySelector('[data-mzbb-stonecount]'); if (statEl) { var nOn = String(Core.inStockStones().length); if (statEl.textContent !== nOn) { statEl.textContent = nOn; } }
    var truncated = total > 16;
    el.showall.hidden = !truncated;
    if (truncated) {
      el.showall.innerHTML = (st.showAll ? 'Show fewer' : 'Show all ' + total + ' stones') +
        '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" style="transform:' + (st.showAll ? 'rotate(180deg)' : 'none') + '; transition:transform .2s ease;" aria-hidden="true"><polyline points="6 9 12 15 18 9"></polyline></svg>';
      css(el.showall, Object.assign({
        width: '100%', marginTop: '14px', padding: '11px', borderRadius: '100px',
        display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '7px',
        fontSize: '11.5px', fontWeight: '600', color: ACCENT, cursor: 'pointer'
      }, GLASS));
    }
  }

  /* ----------------------------------------------------- summary + ATC + sticky bar */
  function renderSummary() {
    var price = st.beads.length ? Core.priceOf(st) : null;
    var bucket = price ? price.bucket : 0;
    var ci = price ? Core.centreIndices(st, st.beads.length) : null;
    var emptyCount = price ? st.beads.filter(function (b, i) { return !b && i !== ci.cube && i !== ci.charm; }).length : 0;
    var placed = price ? (st.beads.length - emptyCount) : 0;
    var complete = price && emptyCount === 0 && !!st.size && !!st.construction;

    /* lines — bucket-based, stones back-computed so the card sums exactly */
    el.lines.textContent = '';
    if (price) {
      var fixed = price.closure + price.cube + price.charm + price.box;
      var stonesShown = Math.max(0, bucket - fixed);
      var lines = [{ label: price.stoneCount ? price.stoneCount + (price.stoneCount === 1 ? ' natural stone' : ' natural stones') : 'No stones placed yet', value: money(stonesShown), to: '[data-stones-anchor]' }];
      if (st.construction === 'magsnap') { lines.push({ label: 'MagSnap 4 · ' + hardware(st.color, st.surface).label, value: money(price.closure), to: '[data-build-anchor]' }); }
      else if (st.construction === 'elastic') { lines.push({ label: 'Korean elastic', value: money(price.closure), to: '[data-build-anchor]' }); }
      if (st.cubeOn) { lines.push({ label: 'Initials cube · ' + CUBE_METAL[st.cubeMetal].label + ' · ' + (st.initials || 'AB').toUpperCase(), value: money(price.cube), to: '[data-centre-anchor]' }); }
      if (price.charm) { var cd = Core.charmDef(st.charm); lines.push({ label: (cd.tab === 'silver' ? '925 silver charm · ' : 'Centre stone · ') + cd.name, value: money(price.charm), to: '[data-centre-anchor]' }); }
      lines.push({ label: st.box === 'luxury' ? 'Luxury box' : 'Signature box', value: st.box === 'luxury' ? money(price.box) : 'Included', to: '[data-pack-anchor]' });
      lines.forEach(function (L) {
        var row = document.createElement('div');
        css(row, { display: 'flex', justifyContent: 'space-between', gap: '12px', fontSize: '12.5px', cursor: 'pointer' });
        row.innerHTML = '<span style="color:#6E737A; min-width:0;">' + L.label + '</span><span style="font-weight:600; white-space:nowrap; color:#15171A;">' + L.value + '</span>';
        row.addEventListener('click', function () { jumpTo(L.to); });
        el.lines.appendChild(row);
      });
    }

    var display = price ? money(bucket) : '—';
    el.total.textContent = display;
    el.stickyprice.textContent = display;

    /* delta — the design's slide-down + fade */
    if (price && lastBucket !== null && bucket !== lastBucket) {
      deltaVal = bucket - lastBucket;
      deltaLabel = (deltaVal > 0 ? '+' : '−') + money(Math.abs(deltaVal));
      clearTimeout(deltaT);
      deltaT = setTimeout(function () { deltaVal = null; applyDelta(); }, 1500);
    }
    lastBucket = price ? bucket : null;
    applyDelta();

    /* cart label + honest gate */
    var authority = Core.getPriceAuthority();
    var canCart = complete && authority === 'runtime';
    var label = complete ? 'Add to Cart'
      : !placed ? 'Place your first stone'
      : emptyCount ? emptyCount + (emptyCount === 1 ? ' bead left to fill' : ' beads left to fill')
      : !st.size ? 'Select your size' : !st.construction ? 'Choose your closure' : 'Add to Cart';
    [el.atc, el.stickyAtc].forEach(function (b) {
      /* ⛔ write into the LABEL SPAN, never the button: b.textContent would wipe out the
         .button__loader element that lives beside it and the spinner would silently vanish. */
      var lbl = b.querySelector('[data-mzbb-atclabel]') || b;
      lbl.textContent = label;
      b.style.background = canCart ? ACCENT : 'rgba(93,139,215,0.12)';
      b.style.color = canCart ? '#fff' : ACCENT;
      b.style.boxShadow = canCart ? '0 4px 16px rgba(93,139,215,0.30)' : 'none';
    });
    el.atcHint.textContent = complete && authority !== 'runtime'
      ? 'Almost there — cart opens when this product goes live. Your design autosaves, and Share keeps a link to it.'
      : '';

    /* progress + step badges */
    var n = st.beads.length || 1;
    el.progress.style.width = Math.round((placed / n) * 100) + '%';
    var curStep = !placed ? 1 : !st.size ? 2 : !st.construction ? 3 : !complete ? 1 : 5;
    $$('[data-mzbb-badge]').forEach(function (b) {
      var k = Number(b.getAttribute('data-mzbb-badge'));
      var glow = (k === 1 && curStep === 1) || (k === 2 && curStep === 2) || (k === 3 && curStep === 3) || (k === 5 && curStep === 5);
      b.style.animation = glow ? 'mesStepPulse 1.9s ease-in-out infinite' : 'none';
    });
  }
  function applyDelta() {
    [ [el.delta, el.totalshift], [el.stickydelta, el.stickyshift] ].forEach(function (pair) {
      pair[0].textContent = deltaLabel;
      pair[0].style.opacity = deltaVal ? '1' : '0';
      pair[1].style.transform = deltaVal ? 'translateY(7px)' : 'none';
    });
  }

  var renderQueued = false;
  function render() {
    if (renderQueued) { return; }
    renderQueued = true;
    /* microtask batching — rAF never fires in hidden tabs (measured 29 Aug) */
    var run = function () {
      renderQueued = false;
      /* self-correcting: viewport emulation (and some in-app webviews) change size without
         firing resize — measured 29 Aug. setupLayout is idempotent, so checking every render
         costs one innerWidth compare and removes the dependency on the event entirely. */
      setupLayout();
      renderRing(); renderControls(); renderGrid(); renderSummary();
    };
    if (typeof queueMicrotask === 'function') { queueMicrotask(run); } else { setTimeout(run, 0); }
  }

  /* --------------------------------------------------------------------------- wiring */
  function wire() {
    $$('[data-mzbb-tile]').forEach(function (t) { t.addEventListener('click', function () { placeStone(t.getAttribute('data-stone')); }); });
    $$('[data-mzbb-sort]').forEach(function (b) {
      b.addEventListener('click', function () {
        var mode = b.getAttribute('data-mzbb-sort');
        if (st.sort === mode) { if (mode !== 'intent') { set({ sortDesc: !st.sortDesc }, { silent: true }); } }
        else { set({ sort: mode, sortDesc: false }, { silent: true }); }
      });
    });
    $$('[data-mzbb-closure]').forEach(function (b) { b.addEventListener('click', function () { pickClosure(b.getAttribute('data-mzbb-closure')); }); });
    el.lux.addEventListener('click', function () { set({ luxOnly: !st.luxOnly, showAll: false }, { silent: true }); });
    el.showall.addEventListener('click', function () { set({ showAll: !st.showAll }, { silent: true }); });
    el.mirror.addEventListener('click', toggleMirror);
    el.mirroryes.addEventListener('click', function () {
      pushHistory();
      var out = st.beads.slice(), n = out.length, i;
      for (i = 0; i < Math.ceil(n / 2); i++) { out[n - 1 - i] = out[i]; }
      set({ beads: out, mirrorAsk: false });
    });
    el.mirrorno.addEventListener('click', function () { set({ mirrorAsk: false }, { silent: true }); });
    el.undo.addEventListener('click', doUndo);
    el.reset.addEventListener('click', doReset);
    el.autofill.addEventListener('click', doAutoFill);
    el.share.addEventListener('click', onShare);
    el.guide.addEventListener('click', function () { set({ guideOpen: !st.guideOpen }, { silent: true }); });
    if (el.sg2) {
      /* the slider picks the size when the finger lets go (one resize per gesture, with the usual undo);
         a chart row picks it on tap */
      el.sg2.addEventListener('mes-sg2w:commit', function (e) {
        var code = e.detail && e.detail.code;
        if (code && Core.sizeRow(code)) { pickSize(code); }
      });
      el.sg2.addEventListener('mes-sg2w:state', function (e) {
        var d = e.detail || {};
        if (d.open !== st.guideOpen) { set({ guideOpen: d.open }, { silent: true }); }
        /* on the chart face the chart is the picker, so the size buttons step aside (product page behaviour) */
        var aside = d.open && d.face === 'back';
        if (aside) { el.sizes.style.maxHeight = el.sizes.scrollHeight + 'px'; void el.sizes.offsetHeight; }
        el.sizes.classList.toggle('is-stepped-aside', aside);
        if (!aside) { setTimeout(function () { if (!el.sizes.classList.contains('is-stepped-aside')) { el.sizes.style.maxHeight = ''; } }, 450); }
      });
    }
    /* V9.28.114 (Shrey, 28 Sep 2026): while the preview is pinned to the top (phones), the site header must NOT
       slide back in on scroll-up - it lands on top of the preview's ring, Share and Auto-saved. The header
       (mes-pdp3-header, hide-on-scroll) reads `mp3-hold-hidden` on <html> and stays up while it is set. Once the
       preview has scrolled away at the end of the builder, the class drops and the header behaves as usual.
       Desktop: the preview is a relative card there (not sticky), so the class is never set. */
    (function () {
      var pv = root.querySelector('[data-sticky-header]');
      if (!pv) { return; }
      var isSticky = false, ticking = false, held = false;
      function measureMode() { isSticky = getComputedStyle(pv).position === 'sticky'; }
      function check() {
        ticking = false;
        var on = false;
        if (isSticky) { var r = pv.getBoundingClientRect(); on = r.top <= 1 && r.bottom > 0; }
        if (on !== held) {
          held = on;
          document.documentElement.classList.toggle('mp3-hold-hidden', on);
          /* the header reads the hold in its own frame, which can run before this one: tell it to re-check */
          document.dispatchEvent(new CustomEvent('mp3:hold-change'));
        }
      }
      function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(check); } }
      measureMode(); check();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', function () { measureMode(); onScroll(); });
    })();
    el.startsummary.addEventListener('click', function () { set({ startOpen: !st.startOpen }, { silent: true }); });
    el.loadedDismiss.addEventListener('click', function () { el.loadedBanner.hidden = true; clearTimeout(loadedT); });
    el.atc.addEventListener('click', addToCart);
    el.stickyAtc.addEventListener('click', addToCart);
    el.stage.addEventListener('click', function () { set({ active: -1, claspActive: false }, { silent: true }); });
    var rs;
    window.addEventListener('resize', function () { clearTimeout(rs); rs = setTimeout(function () { setupLayout(); render(); }, 160); });
  }

  /* ------------------------------------------------ DESKTOP LAYOUT (design file, verbatim)
     `builder/Bracelet Builder Desktop v2.dc.html`: a 1500px shell, header row, then
     grid-template-columns: minmax(320px,1fr) minmax(0,1.1fr); gap 52px. The LEFT column is
     sticky (top 22px) and carries the preview card AND the "Your build" summary; the steps
     flow in the RIGHT column with 44px gaps. No bottom bar. The blocks are all siblings in
     the section, so the layout is a one-time DOM regroup at the breakpoint, reversed cleanly
     below it. 1100px chosen as the switch: the design's left minimum (320) + gap (52) + a
     usable right column. */
  var deskWrap = null;
  /* ⛔ 900, not the design file's implied 1100 (Shrey, 29 Aug: "in such in-between aspect ratios
     it's not optimized properly"). At 1000px the page was still serving the 520px mobile column
     with ~240px of dead space each side. 900 is the narrowest width where the design's own
     left minimum (320) + gap (52) + a usable right column still fit inside the shell padding. */
  function isDesk() { return window.innerWidth >= 900; }
  function setupLayout() {
    var want = isDesk();
    if (want && !deskWrap) {
      var zones = $$('[data-mzbb-zone]');
      var byKind = { hero: [], preview: [], step: [], summary: [], extra: [] };
      zones.forEach(function (z) { byKind[z.getAttribute('data-mzbb-zone')].push(z); });
      deskWrap = document.createElement('div');
      deskWrap.setAttribute('data-mzbb-deskgrid', '');
      css(deskWrap, { display: 'grid', gridTemplateColumns: 'minmax(320px,1fr) minmax(0,1.1fr)', gap: '0 52px', alignItems: 'start', paddingTop: '26px' });
      var left = document.createElement('div');
      left.setAttribute('data-mzbb-deskleft', '');
      css(left, { position: 'sticky', top: '22px', display: 'flex', flexDirection: 'column', gap: '8px' });
      var right = document.createElement('div');
      right.setAttribute('data-mzbb-deskright', '');
      css(right, { display: 'flex', flexDirection: 'column', gap: '24px' });
      var first = byKind.preview[0];
      first.parentNode.insertBefore(deskWrap, first);
      byKind.preview.concat(byKind.summary).forEach(function (z) { left.appendChild(z); });
      byKind.step.forEach(function (z) { right.appendChild(z); });
      deskWrap.appendChild(left);
      deskWrap.appendChild(right);
      root.classList.add('mzbb--desk');
    } else if (!want && deskWrap) {
      /* restore the mobile source order: unwrap in place */
      var parent = deskWrap.parentNode;
      var order = ['preview', 'step', 'summary'];
      var pull = [];
      order.forEach(function (kind) {
        $$('[data-mzbb-zone="' + kind + '"]').forEach(function (z) { pull.push(z); });
      });
      pull.forEach(function (z) { parent.insertBefore(z, deskWrap); });
      parent.removeChild(deskWrap);
      deskWrap = null;
      root.classList.remove('mzbb--desk');
    }
  }

  /* the desktop toolbar has a Mix control: shuffle every bead from the shopper's palette */
  /* ⛔ doMix and the Mix control were REMOVED on Shrey's instruction (30 Aug). The desktop
     design file does carry a Mix button — I checked before removing it rather than assuming —
     but his call overrides design-verbatim, and Undo goes back in its place. */

  /* ----------------------------------------------------------------------------- boot */
  wire();
  setupLayout();
  /* H297 runtime: the shop metafield, rendered by Liquid. Shape { id: {price, inStock} }.
     applyRuntime flips the price authority to `runtime` only when it actually prices rows —
     an empty or malformed blob leaves the snapshot in charge and the cart gated. */
  (function () {
    var rt = readJSON('[data-mzbb-runtime="' + SID + '"]');
    if (!rt) { return; }
    /* V9.28.116: the owner's switch-off list lives in the same metafield (see core: OWNER SWITCHES) */
    Core.applyAvailability(rt._off);
    var rows = Object.keys(rt).filter(function (id) { return id.charAt(0) !== '_'; }).map(function (id) {
      return { id: id, priceINR: rt[id] && typeof rt[id].price === 'number' ? rt[id].price : undefined, inStock: rt[id] ? rt[id].inStock !== false : true };
    });
    Core.applyRuntime(rows);
  })();
  /* ⛔ AFTER the runtime block: presets filter on stock + the owner's switches, which it has only just read (V9.28.116) */
  renderPresets();
  primeClaspAspect();
  if (!tryIncoming() && !tryRestore()) { startOnPreset('Wealth'); }
  render();
  announceCleared();   /* a link or saved design that carried out-of-stock beads (V9.28.116) */
  if (incomingNotice) {
    var inc = incomingNotice; incomingNotice = null;
    var incPrice = null;
    try { incPrice = st.beads.length ? Core.priceOf(st) : null; } catch (e) {}
    customNotice({ custom: incPrice ? incPrice.bucket : null, ready: inc.ready, goLabel: 'Okay, got it' }, null, function () {
      /* Cancel = back to the bracelet they came from */
      var back = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'products/' + inc.handle;
      if (document.referrer && document.referrer.indexOf('/products/' + inc.handle) > -1 && window.history.length > 1) { window.history.back(); }
      else { location.href = back; }
    });
  }

  /* A read-only handle so the variant map's verdict is INSPECTABLE on a real page rather than
     inferred. `mzbb.variantMap()` returns 'ok' | 'stale' | 'unstamped' | 'empty' | 'absent',
     evaluated after applyRuntime, which is the only point at which the answer is meaningful. */
  window.mzbb = {
    variantMap: variantMapState,
    band: function () { return Core.band(); },
    priceAuthority: function () { return Core.getPriceAuthority(); }
  };
})();
